import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Search,
  DeleteForever,
} from "@mui/icons-material";
import "devextreme/data/odata/store";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Card, Col, Container, Dropdown, Form, Modal, Pagination, Row, Table } from "react-bootstrap";
import * as yup from "yup";

import API, { AxiosInstance, Settings } from "../../api/api";
import { parsedUser } from "../../utils/GetCurrentUser";
import { useLocation, useParams } from "react-router-dom";
import { TextBox, SelectBox, DateBox } from "devextreme-react";
import FieldSelector from "../../components/customComponents/FieldSelector";
import { useFormik } from "formik";
import Sha256 from "../../utils/sha256";
import logoSignos from "../../assets/SignosFrameworkLogo.png";

import { useToast } from "../../contexts/toast";
import yupTypeValidator from "../../utils/YupTypeValidator";
import { exportToPDF as GeneratePDF } from '../../utils/export-to-pdf';
import { exportToExcel as GenerateXLS } from '../../utils/export-to-excel';
import { CustomBreadcrumbs as Breadcrumbs } from "../../components";
import useFavorite from "../../hooks/useFavorite";
import moment from "moment";
import "../../index.css";

// Componente personalizado para el botón de cerrar modal
const CustomCloseButton = ({ onClose }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      style={{
        border: "1px solid #b0b0b0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease",
        backgroundColor: isHovered ? "#ff4136" : "",
        cursor: "pointer"
      }}
      className="btn"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClose}
      aria-label="Close"
    >
      <i 
        style={{ 
          fontSize: "20px", 
          color: isHovered ? "#ffffff" : "#b0b0b0",
          transition: "color 0.2s ease"
        }} 
        className="fa-solid fa-xmark"
      ></i>
    </button>
  );
};

export default function CheckIn() {  
  // PROPERTIES
  const user = parsedUser();
  const { pathname } = useLocation();
  const params = useParams();
  const { idModule } = useParams();
  const toast = useToast();

  const [recordCount, setRecordCount] = useState(10); // 10 registros de empleados
  const [totalPages, setTotalPages] = useState(1);
  const [generalError, setGeneralError] = useState(null);
  const [open, setOpen] = useState(false);
  const [actionMode, setActionMode] = useState(null);//I=Insert, U= Update = C= Consultar, D= Delete
  const [loading, setLoading] = useState(false);
  const [loadingFilters, setLoadingFilters] = useState(true); // Estado para controlar carga de filtros
  // const [isPinned, setIsPinned] = useState(false);
  const [isSearching, setIsSearching] = useState(true);
  const checkAudit = localStorage.getItem('AuditInformation')
  const [showTable, setShowTable] = useState(false); // Ocultar tabla hasta que se consulte

  const initialModel = {
    section: {},
    data: {
      Columns: [],
      Rows: [],
      Summary: [],
      Alignment: [],
    },
  }
  const [section, setSection] = useState({ FormTitle: "Check In", FormPath: "", FormIcon: "fa fa-sign-in" });
  const [fields, setFields] = useState([])
  const [filters, setFilters] = useState([]) // Filtros dinámicos del Model
  const [filterValues, setFilterValues] = useState({}); // Valores de los filtros dinámicos
  const [model, setModel] = useState(initialModel);
  const [search, setSearch] = useState(""); // Búsqueda general (string simple)
  const [columnFilters, setColumnFilters] = useState({}); // Filtros por columna (objeto)
  
  // Estados para los filtros de fecha (valores por defecto: primer y último día del mes actual)
  const getFirstDayOfMonth = () => {
    return moment().startOf('month').format('YYYY-MM-DD');
  };
  
  const getLastDayOfMonth = () => {
    return moment().endOf('month').format('YYYY-MM-DD');
  };
  
  const [fechaIni, setFechaIni] = useState(getFirstDayOfMonth());
  const [fechaFin, setFechaFin] = useState(getLastDayOfMonth());
  const [openFilterColumn, setOpenFilterColumn] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [RecordsQuantity, setRecordsQuantity] = useState(10);
  const allowedPageSizes = [{ value: 10, text: 10 }, { value: 20, text: 20 }, { value: 50, text: 50 }, { value: 100, text: 100 }, { value: 0, text: "Todos" }];
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({}); // Para manejar checkboxes individuales
  const [selectAll, setSelectAll] = useState(false); // Para el checkbox de seleccionar todos
  const [isMassiveCheckIn, setIsMassiveCheckIn] = useState(false); // Para identificar Check In Masivo
  const { isPinned, UpdateFavorites, checkIfPinned } = useFavorite()
  const selectedItemRef = useRef(null);
  const [sortBy, setSortBy] = useState('Id')
  const [sortByOrder, setSortByOrder] = useState('DESC')
  
  // Estados para el modal de Check In
  const [fechaCheckIn, setFechaCheckIn] = useState('');
  const [comentarioCheckIn, setComentarioCheckIn] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  
  // Estados para los datos de la plaza seleccionada en Check In
  const [plazaCodigoCheckIn, setPlazaCodigoCheckIn] = useState('');
  const [plazaNombreCheckIn, setPlazaNombreCheckIn] = useState('');
  const [plazaCategoriaCheckIn, setPlazaCategoriaCheckIn] = useState('');
  const [plazaEstadoCheckIn, setPlazaEstadoCheckIn] = useState('');
  
  // Estados para la tabla de detalle dentro del modal
  const [detailItems, setDetailItems] = useState([
    {
      Id: 686,
      Codigo: "V03-202-3A",
      Plaza: "VILLA 03 PISO 2 APT 02 HAB 3 PLAZA A",
      Categoria: "EJECUTIVO",
      Estado: "PLAZA PENDIENTE SALIDA",
      Ocupante: "BELGICA GERALDINE CHIRINOS ACOSTA",
      FechaSalida: "28-04-2025",
      MotivoSalida: "ENTREGA VOLUNTARIA",
      ComentarioSalida: "SALIDA POR ENTREGA VOLUNTARIA EL 28-04-2025"
    },
    {
      Id: 703,
      Codigo: "E01-303-3A",
      Plaza: "EDIF. 01 PISO 3 APT 03 HAB 3 PLAZA A",
      Categoria: "EJECUTIVO",
      Estado: "PLAZA PENDIENTE SALIDA",
      Ocupante: "BENARDO RAMON D. ZIMMERMANN DIAZ",
      FechaSalida: "01-08-2025",
      MotivoSalida: "ENTREGA VOLUNTARIA",
      ComentarioSalida: "SALIDA POR ENTREGA VOLUNTARIA EL 01-08-2025"
    },
    {
      Id: 880,
      Codigo: "E08-501-4A",
      Plaza: "EDIF. 08 PISO 5 APT 01 HAB 4 PLAZA A",
      Categoria: "EJECUTIVO",
      Estado: "PLAZA PENDIENTE SALIDA",
      Ocupante: "CARLOS MARTIN LOPEZ",
      FechaSalida: "30-04-2025",
      MotivoSalida: "ENTREGA VOLUNTARIA",
      ComentarioSalida: "SALIDA POR ENTREGA VOLUNTARIA EL 30-04-2025"
    },
    {
      Id: 1016,
      Codigo: "E08-103-4A",
      Plaza: "EDIF. 08 PISO 1 APT 03 HAB 4 PLAZA A",
      Categoria: "EJECUTIVO",
      Estado: "DISPONIBLE PARA USO",
      Ocupante: "CHELSEA IRIS GARCIA BAEZ",
      FechaSalida: "28-06-2025",
      MotivoSalida: "BAJA",
      ComentarioSalida: "SALIDA POR BAJA EL 28-06-2025"
    }
  ]);
  const [newDetailItem, setNewDetailItem] = useState({ campo1: '', campo2: '' });
  
  // Estados para los campos de asignación
  const [selectedCodigo, setSelectedCodigo] = useState('');
  const [selectedNombre, setSelectedNombre] = useState('');
  const [selectedGenero, setSelectedGenero] = useState('');
  const [selectedFechaNac, setSelectedFechaNac] = useState('');
  const [selectedEdad, setSelectedEdad] = useState('');
  const [selectedTipo, setSelectedTipo] = useState('');
  const [selectedCategoria, setSelectedCategoria] = useState('');
  const [selectedDepartamento, setSelectedDepartamento] = useState('');
  const [selectedNivelPuesto, setSelectedNivelPuesto] = useState('');
  const [selectedCargo, setSelectedCargo] = useState('');
  const [selectedTipoVivienda, setSelectedTipoVivienda] = useState('');
  
  // Funciones para manejar la tabla de detalle
  const addDetailItem = () => {
    if (newDetailItem.campo1 && newDetailItem.campo2) {
      setDetailItems([...detailItems, { ...newDetailItem, id: Date.now() }]);
      setNewDetailItem({ campo1: '', campo2: '' });
    }
  };
  
  const removeDetailItem = (id) => {
    setDetailItems(detailItems.filter(item => item.id !== id));
  };
  
  // Filter helper functions
  const updateColumnFilter = (fieldName, value) => {
    setColumnFilters(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  // Función para seleccionar/deseleccionar todos los checkboxes
  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    
    // Crear un objeto con todos los items marcados o desmarcados
    const newSelectedCheckboxes = {};
    if (newSelectAll && model?.data?.Rows) {
      model.data.Rows.forEach((item, index) => {
        newSelectedCheckboxes[index] = true;
      });
    }
    setSelectedCheckboxes(newSelectedCheckboxes);
    
    console.log(`✅ ${newSelectAll ? 'Todos los items seleccionados' : 'Todos los items deseleccionados'}`);
    console.log('Total items:', model?.data?.Rows?.length || 0);
  };

  // Función para manejar el toggle de un checkbox individual
  const handleCheckboxToggle = (index) => {
    const newSelectedCheckboxes = {
      ...selectedCheckboxes,
      [index]: !selectedCheckboxes[index]
    };
    setSelectedCheckboxes(newSelectedCheckboxes);
    
    // Actualizar el estado de "seleccionar todos" si todos están seleccionados
    const allSelected = model?.data?.Rows && model.data.Rows.every((_, idx) => newSelectedCheckboxes[idx]);
    setSelectAll(allSelected || false);
    
    const selectedCount = Object.values(newSelectedCheckboxes).filter(val => val === true).length;
    console.log(`✅ Item ${index} ${newSelectedCheckboxes[index] ? 'seleccionado' : 'deseleccionado'}. Total seleccionados: ${selectedCount}`);
  };

  // Función helper para obtener los items seleccionados
  const getSelectedItems = () => {
    if (!model?.data?.Rows) return [];
    
    return model.data.Rows.filter((_, index) => selectedCheckboxes[index]);
  };

  // Función helper para obtener solo los items seleccionados que tienen CheckIn habilitado
  const getSelectedItemsWithCheckInEnabled = () => {
    if (!model?.data?.Rows) return [];
    
    return model.data.Rows.filter((item, index) => {
      // Solo considerar items seleccionados
      if (!selectedCheckboxes[index]) return false;
      
      // Verificar si tiene CheckIn habilitado (nuevo formato booleano)
      return item.CheckIn === true || item.CheckIn === "true";
    });
  };

  // Función para verificar si hay items seleccionados
  const hasSelectedItems = () => {
    return Object.values(selectedCheckboxes).some(val => val === true);
  };

  // Función para inicializar valores por defecto de los filtros
  const initializeFilterDefaults = useCallback((filters) => {
    const defaults = {};
    const today = new Date();
    
    filters.forEach(filter => {
      if (filter.Default) {
        // Usar el valor Default del API si existe
        let defaultValue = filter.Default;
        
        // Si el filtro es de tipo date, convertir formato DD-MM-YYYY a YYYY-MM-DD
        if (filter.HtmlType === 'date' && typeof defaultValue === 'string') {
          // Verificar si viene en formato DD-MM-YYYY
          if (defaultValue.includes('-') && defaultValue.length === 10) {
            const parts = defaultValue.split('-');
            if (parts.length === 3 && parts[0].length <= 2) {
              // Convertir de DD-MM-YYYY a YYYY-MM-DD
              defaultValue = `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
          }
        }
        
        defaults[filter.FieldName] = defaultValue;
      } else if (filter.HtmlType === 'date') {
        // Si el filtro es FechaEntrada o contiene "Inicio" -> primer día del mes
        if (filter.FieldName === 'FechaEntrada' || filter.FieldTitle.includes('Inicio')) {
          const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
          defaults[filter.FieldName] = firstDay.toISOString().split('T')[0];
        }
        // Si el filtro es FechaSalida o contiene "Fin" -> último día del mes
        else if (filter.FieldName === 'FechaSalida' || filter.FieldTitle.includes('Fin')) {
          const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          defaults[filter.FieldName] = lastDay.toISOString().split('T')[0];
        }
      } else {
        defaults[filter.FieldName] = '';
      }
    });
    
    return defaults;
  }, []);

  const clearAllFilters = async () => {
    setSearch("");
    setColumnFilters({});
    setOpenFilterColumn(null);
    setShowTable(false); // Ocultar tabla al limpiar filtros
    
    // Limpiar selección de checkboxes
    setSelectedCheckboxes({});
    setSelectAll(false);
    
    // Restaurar valores por defecto de los filtros dinámicos usando la función helper
    const defaultValues = initializeFilterDefaults(filters);
    setFilterValues(defaultValues);
    
    // Limpiar datos de la tabla
    setModel({
      ...model,
      data: {
        ...model.data,
        Rows: []
      }
    });
    setRecordCount(0);
  };

  const toggleFilterDropdown = (fieldName) => {
    setOpenFilterColumn(openFilterColumn === fieldName ? null : fieldName);
  };

  const applyColumnFilter = async () => {
    setOpenFilterColumn(null);
    await bindDataRemote();
    await bindDataCountRemote();
  };

  const clearSingleColumnFilter = async (fieldName) => {
    setColumnFilters(prev => {
      const newFilters = { ...prev };
      delete newFilters[fieldName];
      return newFilters;
    });
    setTimeout(async () => {
      await bindDataRemote();
      await bindDataCountRemote();
    }, 100);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openFilterColumn && !event.target.closest('.position-relative')) {
        setOpenFilterColumn(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openFilterColumn]);
  
  // END PROPERTIES



  //METHODS
  ///BRING THE DATA FROM THE SERVER FOR MODEL AND RECORDS
  const bindDataRemote = useCallback(async (cleanFilter) => {

    // First start loading the model
    setLoading(true);

    //First load records

    try {
      let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      
      // Filtrar solo los campos con valores no vacíos
      const activeFilters = Object.keys(columnFilters).reduce((acc, key) => {
        const value = columnFilters[key];
        if (value !== null && value !== undefined && value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {});

      // Filtros por columna tienen prioridad sobre búsqueda general
      if (Object.keys(activeFilters).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(activeFilters));
      } else if (search.length > 0 && cleanFilter == null) {
        // Búsqueda general solo si no hay filtros de columna
        query += "&Search=" + search;
      }
      
      // Garantizar que RecordsQuantity sea un número válido, usar 10 por defecto
      const quantityNumber = Number(RecordsQuantity) || 10;
      
      query += `&PageNumber=${currentPage}&Quantity=${quantityNumber}&SortBy=${sortBy}&SortType=${sortByOrder}`;
      
      console.log("🔍 QUERY Records:", query);
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.getAction(`api/${prefix}/ReportRecords`, query);
      
      console.log("🔍 RAW Response:", request.data);
      
      // Para reportes, la respuesta puede venir directamente como array
      let dataFromAPI = [];
      let summaryFromAPI = [];
      let alignmentFromAPI = [];
      
      if (Array.isArray(request.data) && request.data.length > 0) {
        // Si viene directamente como array de objetos
        if (request.data[0].JSONData) {
          // Caso 1: Viene con JSONData wrapper
          let results = request.data[0];
          let parsedResults = JSON.parse(results.JSONData);
          console.log("📊 Parsed Results:", parsedResults);
          console.log("🔍 parsedResults.JSONData:", parsedResults.JSONData);
          console.log("🔍 parsedResults.Count:", parsedResults.Count);
          if (parsedResults.JSONData) {
            console.log("🔍 parsedResults.JSONData.Count:", parsedResults.JSONData.Count);
            console.log("🔍 parsedResults.JSONData.Data:", parsedResults.JSONData.Data);
          }
          
          // Verificar si viene en el formato nuevo con ReportData
          if (parsedResults.ReportData && parsedResults.ReportData.Data) {
            dataFromAPI = parsedResults.ReportData.Data;
            summaryFromAPI = parsedResults.ReportData.Summary || [];
            alignmentFromAPI = parsedResults.ReportData.Alignment || [];
            console.log("📊 Caso 1A - Con ReportData.Data:", dataFromAPI);
            console.log("📊 Summary:", summaryFromAPI);
            console.log("📊 Alignment:", alignmentFromAPI);
          } else if (parsedResults.JSONData) {
            // Nuevo formato: JSONData con Data, Count, etc.
            if (parsedResults.JSONData.Data) {
              dataFromAPI = parsedResults.JSONData.Data;
              console.log("📊 Caso 1C - Con JSONData.Data:", dataFromAPI);
            } else {
              dataFromAPI = parsedResults.JSONData;
              console.log("📊 Caso 1D - Con JSONData directo:", dataFromAPI);
            }
            
            // Extraer Count si viene en JSONData.Count o directamente en parsedResults.Count
            let countSource = parsedResults.JSONData.Count || parsedResults.Count;
            if (countSource) {
              let countFromAPI = 0;
              
              // Si countSource es un string, intentar parsearlo
              if (typeof countSource === 'string') {
                try {
                  // Limpiar escapes
                  let cleanedJson = countSource
                    .replace(/\\/g, '') // Eliminar todos los backslashes
                    .replace(/,(\s*[\]}])/g, '$1'); // Eliminar comas antes de ] o }
                  
                  countSource = JSON.parse(cleanedJson);
                  console.log("📊 Count parseado desde string:", countSource);
                } catch (e) {
                  console.warn("⚠️ No se pudo parsear Count como JSON:", e);
                }
              }
              
              if (Array.isArray(countSource) && countSource.length > 0) {
                countFromAPI = countSource[0].Count || 0;
              } else if (typeof countSource === 'number') {
                countFromAPI = countSource;
              } else if (countSource && typeof countSource === 'object' && countSource.Count) {
                countFromAPI = countSource.Count;
              }
              console.log("📊 Count extraído en bindDataRemote:", countFromAPI);
              setRecordCount(countFromAPI);
            }
          } else if (Array.isArray(parsedResults) && parsedResults[0]) {
            // Formato antiguo
            let recordResult = parsedResults[0].JSONData || [];
            dataFromAPI = recordResult[0] ? (recordResult[0].JSONConfig ? recordResult[0].JSONData : recordResult) : [];
            console.log("📊 Caso 1B - Formato antiguo con array:", dataFromAPI);
          }
        } else {
          // Caso 2: Viene directamente como array (reportes)
          dataFromAPI = request.data;
          console.log("📊 Caso 2 - Array directo (reportes):", dataFromAPI);
        }
      }
      
      console.log("✅ Final dataFromAPI:", dataFromAPI);
      console.log("✅ Final summaryFromAPI:", summaryFromAPI);
      console.log("✅ Final alignmentFromAPI:", alignmentFromAPI);


      //TODO: | Use JSONConfig to show specific fields
      let gridData = null;
      let gridColumns = dataFromAPI && dataFromAPI.length > 0 ? Object.keys(dataFromAPI[0]).filter(x => !x.startsWith("Id")) : null;

      //! If grid data stays null, we use the data from the API

      let titles = ['Audit Information', 'Added by', 'Date Added', 'Modified by', 'Last Modified']

      /*setModel({
        ...model,

        data: {
          ...model.data,
          Columns: gridColumns,
          Rows: gridData || dataFromAPI,
        },
      }); */
      //debugger;
      setModel({
        ...model,
        
        data: {
          ...model.data,
          Columns: gridColumns,
          Rows: dataFromAPI,
          Summary: summaryFromAPI,
          Alignment: alignmentFromAPI,
        },
      });



    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, search, columnFilters, sortBy, sortByOrder, RecordsQuantity, params.id, idModule]);


  // useEffect(() => {
  //   setTableHeader([])
  //   setSelectedItem(null);
  //   setSelectedItemIndex(null);
  //   bindDataRemote();
  //   bindDataCountRemote();
  // }, [params.id, idModule, bindDataRemote])

  // Limpiar selección cuando cambia la página
  useEffect(() => {
    setSelectedItem(null);
    setSelectedItemIndex(null);
  }, [currentPage])

  const bindDataCountRemote = async (cleanFilter) => {

    // First start loading the model
    //setLoading(true);

    //First load records

    try {
      let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      
      // Filtrar solo los campos con valores no vacíos
      const activeFilters = Object.keys(columnFilters).reduce((acc, key) => {
        const value = columnFilters[key];
        if (value !== null && value !== undefined && value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {});

      // Filtros por columna tienen prioridad sobre búsqueda general
      if (Object.keys(activeFilters).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(activeFilters));
      } else if (search.length > 0 && cleanFilter == null) {
        // Búsqueda general solo si no hay filtros de columna
        query += "&Search=" + search;
      }
      
      console.log("🔍 QUERY RecordsCount:", query);
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.getAction(`api/${prefix}/RecordsCount`, query);

      console.log("🔍 RAW RecordsCount Response:", request.data);
      
      let count = 0;
      if (Array.isArray(request.data) && request.data.length > 0) {
        if (request.data[0].JSONData) {
          // Caso con JSONData wrapper
          let results = request.data[0];
          let parsedResults = JSON.parse(results.JSONData);
          console.log("📊 Parsed RecordsCount Results:", parsedResults);
          
          // Verificar si viene en el formato nuevo con ReportData
          if (parsedResults.ReportData?.Count !== undefined) {
            count = parsedResults.ReportData.Count;
            console.log("📊 RecordsCount - Con ReportData.Count:", count);
          } else if (parsedResults[0]?.JSONData?.Count !== undefined) {
            count = parsedResults[0].JSONData.Count;
            console.log("📊 RecordsCount - Formato antiguo con Count:", count);
          } else if (parsedResults.Count !== undefined) {
            count = parsedResults.Count;
            console.log("📊 RecordsCount - Count directo en parsedResults:", count);
          } else {
            count = request.data[0].Count || 0;
            console.log("📊 RecordsCount - Count en data[0]:", count);
          }
        } else {
          // Caso directo
          count = request.data[0].Count || 0;
          console.log("📊 RecordsCount - Directo:", count);
        }
      }
      
      setRecordCount(count);
      console.log("✅ Final Record Count:", count)


    } catch (error) {
      console.error(error);
    } finally {
      // setLoading(false);
    }
  };

  const bindDataModelRemote = async (cleanFilter) => {


    try {

      let prefix = idModule ? "CRUDDynamic" : "CRUD";

      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      let requestSections = await API.getAction(`api/${prefix}/Model`, querySections);
      
      console.log("🔍 RAW Model Response:", requestSections.data);
      
      let recordResultSection = null;
      
      if (Array.isArray(requestSections.data) && requestSections.data.length > 0) {
        if (requestSections.data[0].JSONData) {
          // Caso con JSONData wrapper
          let resultsSections = requestSections.data[0];
          let parsedResultsSections = JSON.parse(resultsSections.JSONData);
          
          if (parsedResultsSections.Error || (parsedResultsSections[0] && parsedResultsSections[0].Error)) {
            alert(parsedResultsSections.Msg || parsedResultsSections[0].Msg);
            return;
          }
          
          // El Model puede venir en ReportData o en JSONData
          recordResultSection = parsedResultsSections.ReportData || parsedResultsSections[0]?.JSONData || parsedResultsSections;
          console.log("📊 Model - Con wrapper:", recordResultSection);
        } else {
          // Caso directo
          recordResultSection = requestSections.data;
          console.log("📊 Model - Directo:", recordResultSection);
        }
      }

      //! If grid data stays null, we use the data from the API
      let titles = ['Informacion de auditoria']
      
      // Asegurarse de que recordResultSection sea un objeto, no un array
      let sectionData = Array.isArray(recordResultSection) ? recordResultSection[0] : recordResultSection;
      
      console.log("✅ Final Section Data:", sectionData);
      
      if (sectionData) {
        // Asegurar que sectionData tenga al menos los campos básicos
        const completeSection = {
          FormTitle: sectionData.FormTitle || sectionData.ReportTitle || "Reporte",
          FormPath: sectionData.FormPath || "Reportes",
          FormIcon: sectionData.FormIcon || "fa fa-file",
          Type: sectionData.Type || "report",
          ...sectionData
        };
        
        setSection(completeSection);
        console.log("✅ Section configurado:", completeSection);
        
        if (sectionData.Fields) {
          setFields(sectionData.Fields.filter((item) => !titles.includes(item.FieldTitle)));
          console.log("✅ Fields configurados:", sectionData.Fields.length);
        }
        
        // Cargar filtros dinámicos si existen
        if (sectionData.Filters && sectionData.Filters.length > 0) {
          setFilters(sectionData.Filters);
          console.log("✅ Filtros cargados:", sectionData.Filters);
          
          // Inicializar valores por defecto de los filtros inmediatamente
          const defaultValues = initializeFilterDefaults(sectionData.Filters);
          setFilterValues(defaultValues);
          console.log("✅ Filtros inicializados inmediatamente con valores:", defaultValues);
        } else {
          setFilters([]);
          console.log("⚠️ No hay filtros definidos en el modelo");
        }
      } else {
        console.error("❌ No se pudo obtener sectionData del Model");
      }

    } catch (error) {
      console.error(error);
    } finally {
      //  setLoading(false);
    }
  };
  const [formSize, setFormSize] = useState('md');
  const [tableHeader, setTableHeader] = useState([]);
  useEffect(() => {

  })
  const bindDataHeaderRemote = async (cleanFilter) => {


    try {

      let prefix = idModule ? "CRUDDynamic" : "CRUD";

      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      let requestSections = await API.getAction(`api/${prefix}/Header`, querySections);
      
      console.log("🔍 RAW Header Response:", requestSections.data);
      
      let recordResultSection = null;
      
      if (Array.isArray(requestSections.data) && requestSections.data.length > 0) {
        if (requestSections.data[0].JSONData) {
          // Caso con JSONData wrapper
          let resultsSections = requestSections.data[0];
          let parsedResultsSections = JSON.parse(resultsSections.JSONData);
          
          console.log("📊 Header parsedResults:", parsedResultsSections);
          
          if (parsedResultsSections.Error || (parsedResultsSections[0] && parsedResultsSections[0].Error)) {
            alert(parsedResultsSections.Msg || parsedResultsSections[0].Msg);
            return;
          }
          
          recordResultSection = parsedResultsSections.ReportData || parsedResultsSections[0]?.JSONData || parsedResultsSections;
          console.log("📊 Header - Con wrapper:", recordResultSection);
        } else {
          // Caso directo
          recordResultSection = requestSections.data;
          console.log("📊 Header - Directo:", recordResultSection);
        }
      }

      //! If grid data stays null, we use the data from the API
      let titles = ['Informacion de auditoria']
      
      // Asegurarse de que recordResultSection sea un objeto/array
      let headerData = Array.isArray(recordResultSection) ? recordResultSection[0] : recordResultSection;
      
      console.log("✅ Final Header Data:", headerData);
      
      if (headerData) {
        setFormSize(headerData.FormSize ?? 'md');
        
        if (headerData.Fields) {
          setTableHeader(headerData.Fields);
          console.log("✅ Table Header Fields:", headerData.Fields);
        }
      }

    } catch (error) {
      console.error(error);
    } finally {
      //  setLoading(false);
    }
  };

  
  /*
    Added by Victor: Actualiza las funciones de getTableHeaders y getTableData para cambiar 
    el tipo de solicitud de POST a GET segun el endpoint de /api/OcupacionProcesos/OcupacionProcesoAsignacion
  */
  // Función para obtener los headers de la tabla principal desde OcupacionProcesos
  // Función para cargar solo los filtros y headers (sin data)
  const loadFiltersAndHeaders = async () => {
    try {
      setLoadingFilters(true); // Iniciar carga de filtros
      console.log("🔍 Cargando filtros y headers de CheckIn...");
      
      // Construir la URL mínima solo para obtener estructura
      // Incluir fechas por defecto para que el API retorne la estructura completa
      let query = `IdUser=${user.IdUser}&Token=${user.Token}&PageNumber=1&RowsOfPage=1&FechaIni=${getFirstDayOfMonth()}&FechaFin=${getLastDayOfMonth()}`;
      
      // Hacer la petición GET al endpoint de CheckIn
      const response = await API.getAction(`api/OcupacionProcesos/OcupacionProcesoCheckIn?${query}`, null);
      
      console.log("📋 Response inicial CheckIn:", response.data);
      
      // Verificar que la respuesta existe
      if (response.data && response.data.length > 0) {
        console.log("📋 Raw response.data[0] inicial:", response.data[0]);
        
        // PASO 1: Verificar si JSONData es un string o ya es un objeto
        let firstLevel;
        if (typeof response.data[0].JSONData === 'string') {
          firstLevel = JSON.parse(response.data[0].JSONData);
          console.log("📋 Primera capa (parseada desde string):", firstLevel);
        } else {
          firstLevel = response.data[0].JSONData;
          console.log("📋 Primera capa (ya es objeto):", firstLevel);
        }
        
        // Verificar errores
        if (firstLevel.Error) {
          toast({
            type: "error",
            message: firstLevel.Msg || "Error al cargar configuración"
          });
          return;
        }
        
        // 👇 Extraer Section (FormPath, FormTitle, FormIcon) directamente desde JSONData
        if (firstLevel.JSONData) {
          const sectionData = firstLevel.JSONData;
          console.log("📋 Section data encontrada:", sectionData);
          
          setSection(prev => ({
            ...prev,
            FormPath: sectionData.FormPath || prev.FormPath || "",
            FormTitle: sectionData.FormTitle || prev.FormTitle || "Check In",
            FormIcon: sectionData.FormIcon || prev.FormIcon || "fa fa-sign-in"
          }));
          console.log("✅ Section actualizada con FormPath:", sectionData.FormPath);
        }
        
        // Extraer Model (headers) y Filter desde firstLevel.JSONData
        let headers = [];
        let filtersFromAPI = [];
        let countFromAPI = 0;
        
        if (firstLevel.JSONData && firstLevel.JSONData.Model) {
          headers = firstLevel.JSONData.Model;
          console.log("📋 Headers extraídos desde JSONData.Model:", headers);
        }
        
        if (firstLevel.JSONData && firstLevel.JSONData.Filter) {
          filtersFromAPI = firstLevel.JSONData.Filter;
          console.log("📋 Filtros extraídos desde JSONData.Filter:", filtersFromAPI);
          setFilters(filtersFromAPI);
          
          // Inicializar valores por defecto de los filtros inmediatamente
          const defaultValues = initializeFilterDefaults(filtersFromAPI);
          setFilterValues(defaultValues);
          console.log("✅ Filtros inicializados inmediatamente con valores:", defaultValues);
        }
        
        // Extraer Count si viene en el response
        if (firstLevel.JSONData && firstLevel.JSONData.Count) {
          if (Array.isArray(firstLevel.JSONData.Count) && firstLevel.JSONData.Count.length > 0) {
            countFromAPI = firstLevel.JSONData.Count[0].Count || 0;
          } else if (typeof firstLevel.JSONData.Count === 'number') {
            countFromAPI = firstLevel.JSONData.Count;
          }
          console.log("📊 Count extraído desde JSONData.Count:", countFromAPI);
          setRecordCount(countFromAPI);
        }
        
        // Cargar todos los campos del Model (sin filtrar aquí)
        // El filtrado se hará en cada componente según ListVisible o Visible
        if (headers && headers.length > 0) {
          const formattedFields = headers.map(field => ({
            FieldName: field.FieldName,
            FieldTitle: field.FieldTitle || field.FieldName,
            Alignment: field.Alignment || 'left',
            Visible: field.Visible !== false,
            ListVisible: field.ListVisible !== false,
            HtmlType: field.HtmlType || 'text',
            cssClass: field.cssClass || 'col-12 col-md-6',
            ReadOnly: field.ReadOnly !== false,
            Sort: field.Sort
          }));
          
          // Actualizar el estado de fields con los headers obtenidos
          setFields(formattedFields);
          
          console.log("✅ Headers CheckIn procesados:", formattedFields);
          console.log("✅ Filtros CheckIn procesados:", filtersFromAPI);
        }
      }
      
    } catch (error) {
      console.error("❌ Error al cargar filtros y headers de CheckIn:", error);
      toast({
        type: "error",
        message: "No se pudo cargar la configuración inicial"
      });
    } finally {
      setLoadingFilters(false); // Finalizar carga de filtros
    }
  };

  // Función para obtener los datos de la tabla desde CheckIn
  const getTableData = async () => {
    try {
      console.log("🔍 Obteniendo datos de CheckIn...");
      setLoading(true);
      
      // Construir la URL con los parámetros base para CheckIn
      let query = `IdUser=${user.IdUser}&Token=${user.Token}&PageNumber=${currentPage}&RowsOfPage=${RecordsQuantity || 10}`;
      
      // Agregar filtros dinámicos a la query, usando siempre FechaIni y FechaFin
      filters.forEach(filter => {
        const value = filterValues[filter.FieldName] || filter.DefaultValue;
        if (value) {
          // Mapear nombres de filtros a los nombres esperados por el API
          let paramName = filter.FieldName;
          
          // Si el campo contiene "entrada" o "inicio", usar FechaIni
          if (filter.FieldName.toLowerCase().includes('entrada') || 
              filter.FieldName.toLowerCase().includes('inicio') ||
              filter.FieldName.toLowerCase().includes('ini')) {
            paramName = 'FechaIni';
          }
          // Si el campo contiene "salida" o "fin", usar FechaFin
          else if (filter.FieldName.toLowerCase().includes('salida') || 
                   filter.FieldName.toLowerCase().includes('fin')) {
            paramName = 'FechaFin';
          }
          
          query += `&${paramName}=${encodeURIComponent(value)}`;
        }
      });
      
      console.log("🔍 Query completo CheckIn:", query);
      console.log("🔍 Filtros aplicados:", filterValues);
      
      // Hacer la petición GET al endpoint de CheckIn
      const response = await API.getAction(`api/OcupacionProcesos/OcupacionProcesoCheckIn?${query}`, null);
      
      console.log("📊 Data Response CheckIn:", response.data);
      
      // Verificar que la respuesta existe
      if (response.data && response.data.length > 0) {
        console.log("📊 Raw response.data[0]:", response.data[0]);
        
        // PASO 1: Verificar si JSONData es un string o ya es un objeto
        let firstLevel;
        if (typeof response.data[0].JSONData === 'string') {
          firstLevel = JSON.parse(response.data[0].JSONData);
          console.log("📊 Primera capa (parseada desde string):", firstLevel);
        } else {
          firstLevel = response.data[0].JSONData;
          console.log("📊 Primera capa (ya es objeto):", firstLevel);
        }
        
        // Verificar si hay error
        if (firstLevel.Error) {
          toast({
            type: "error",
            message: firstLevel.Msg || "Error al obtener datos"
          });
          setLoading(false);
          return;
        }
        
        // Extraer el array de datos desde firstLevel.JSONData.Data
        let dataRows = [];
        let totalCount = 0;
        
        if (firstLevel.JSONData && firstLevel.JSONData.Data) {
          dataRows = firstLevel.JSONData.Data;
          console.log("📊 Datos extraídos desde JSONData.Data:", dataRows);
          
          // EXTRAER EL COUNT CORRECTO DEL API
          let countSource = firstLevel.JSONData.Count || firstLevel.Count;
          console.log("🔍 countSource encontrado:", countSource);
          
          if (countSource) {
            // Si countSource es un string, parsearlo
            if (typeof countSource === 'string') {
              try {
                let cleanedJson = countSource
                  .replace(/\\/g, '') // Eliminar todos los backslashes
                  .replace(/,(\s*[\]}])/g, '$1'); // Eliminar comas antes de ] o }
                
                countSource = JSON.parse(cleanedJson);
                console.log("📊 Count parseado desde string:", countSource);
              } catch (e) {
                console.warn("⚠️ No se pudo parsear Count como JSON:", e);
              }
            }
            
            // Extraer el número del Count
            if (Array.isArray(countSource) && countSource.length > 0) {
              totalCount = countSource[0].Count || 0;
            } else if (typeof countSource === 'number') {
              totalCount = countSource;
            } else if (countSource && typeof countSource === 'object' && countSource.Count) {
              totalCount = countSource.Count;
            }
            
            console.log("✅ Count extraído del API:", totalCount);
          } else {
            // Si no viene Count del API, usar el length como fallback
            totalCount = dataRows.length;
            console.log("⚠️ No se encontró Count en el API, usando length:", totalCount);
          }
        } else if (firstLevel.Data) {
          // A veces los datos vienen directamente en firstLevel.Data
          dataRows = firstLevel.Data;
          totalCount = dataRows.length;
          console.log("📊 Datos extraídos desde Data directo:", dataRows);
        } else if (Array.isArray(firstLevel.JSONData)) {
          // A veces JSONData es directamente el array
          dataRows = firstLevel.JSONData;
          totalCount = dataRows.length;
          console.log("📊 JSONData es el array directo:", dataRows);
        }
        
        console.log("✅ Datos finales extraídos CheckIn:", dataRows);
        console.log("✅ Total registros en esta página:", dataRows.length);
        console.log("✅ Total registros en la BD:", totalCount);
        if (dataRows.length > 0) {
          console.log("✅ Primer registro (muestra):", dataRows[0]);
        }
        
        // Resetear selección de checkboxes al cargar nuevos datos
        setSelectedCheckboxes({});
        setSelectAll(false);
        
        // Actualizar el modelo con los datos obtenidos
        const newModel = {
          ...model,
          data: {
            ...model.data,
            Rows: dataRows
          }
        };
        
        console.log("📊 Modelo actualizado con datos:", newModel);
        console.log("📊 Fields actuales:", fields);
        
        setModel(newModel);
        
        // Actualizar el conteo de registros CON EL COUNT REAL DEL API
        setRecordCount(totalCount);
        
        toast({
          type: "success",
          message: `Se encontraron ${dataRows.length} registro(s)`
        });
        
        return dataRows;
      } else {
        // No hay datos
        setModel({
          ...model,
          data: {
            ...model.data,
            Rows: []
          }
        });
        setRecordCount(0);
        
        toast({
          type: "info",
          message: "No se encontraron registros"
        });
      }
      
    } catch (error) {
      console.error("❌ Error al obtener datos de CheckIn:", error);
      toast({
        type: "error",
        message: "No se pudieron cargar los datos de la tabla"
      });
    } finally {
      setLoading(false);
    }
  };

  /*
    Added by Victor: Agrega la funcion getPlazasDisponibles
  */
 // Agregar esta función después de getTableData (alrededor de la línea 837)

  const getPlazasDisponibles = async (idColaborador) => {
    try {
      console.log("🏠 Obteniendo plazas disponibles para colaborador:", idColaborador);
      setLoading(true);
      
      // Construir la query string con los parámetros en la URL
      const query = `ActionMode=PD&IdColaborador=${idColaborador}&JsonParams=${encodeURIComponent("{}")}&Token=${user.Token}`;
      
      console.log("🔍 Query completo:", query);
      console.log("🔍 URL completa:", `api/OcupacionProcesos/OcupacionProcesoAsignacionHelper?${query}`);
      
      // Hacer la petición POST con los parámetros en la URL
      const response = await API.postAction(
        `api/OcupacionProcesos/OcupacionProcesoAsignacionHelper?${query}`,
        null  // Body vacío o null
      );
      
      console.log("📥 Plazas Response:", response.data);
      
      // Verificar que la respuesta existe
      if (response.data && response.data.length > 0) {
        // Parsear el primer nivel de JSONData
        let firstLevel = JSON.parse(response.data[0].JSONData);
        console.log("📋 Primera capa parseada:", firstLevel);
        
        // Verificar errores
        if (firstLevel.Error) {
          toast({
            type: "error",
            message: firstLevel.Msg || "Error al obtener plazas"
          });
          setDetailItems([]);
          setLoading(false);
          return;
        }
        
        // Extraer Model (headers) y Data (plazas)
        let plazasHeaders = [];
        let plazasData = [];
        
        if (firstLevel.JSONData && firstLevel.JSONData.Model) {
          plazasHeaders = firstLevel.JSONData.Model;
          console.log("📋 Headers de plazas:", plazasHeaders);
        }
        
        if (firstLevel.JSONData && firstLevel.JSONData.Data) {
          plazasData = firstLevel.JSONData.Data;
          console.log("🏠 Plazas disponibles:", plazasData);
        }
        
        // Actualizar el estado con las plazas obtenidas
        setDetailItems(plazasData);
        
        console.log("✅ Plazas cargadas exitosamente:", plazasData.length);
        
        toast({
          type: "success",
          message: `Se encontraron ${plazasData.length} plaza(s) disponible(s)`
        });
        
        return { headers: plazasHeaders, data: plazasData };
      } else {
        // No hay datos
        setDetailItems([]);
        
        toast({
          type: "info",
          message: "No se encontraron plazas disponibles"
        });
      }
      
    } catch (error) {
      console.error("❌ Error al obtener plazas:", error);
      toast({
        type: "error",
        message: "No se pudieron cargar las plazas disponibles"
      });
      setDetailItems([]);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => { 
  //   if (checkAudit !== null) {
  //     bindDataRemote();
  //   }
  // }, [checkAudit, bindDataRemote])

  // const bindDataDetailsRemote = async (recordId) => {
  //   //First load records
  //   try {
  //     let prefix = idModule ? "CRUDDynamic" : "CRUD";
  //     let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}&RecordId=${recordId}${idModule ? "&IdModule=" + idModule : ""}`;
  //     let request = await API.getAction(`api/${prefix}/Details`, query);
  //     let results = request.data[0];

  //     let parsedResults = JSON.parse(results.JSONData)[0];
  //     if (parsedResults.Error) {
  //       alert(parsedResults.Msg);
  //       return;
  //     }

  //     let finalResult = parsedResults.JSONData;
  //     fillFormikObject(finalResult);
  //     setSelectedItem(null);
  //     setSelectedItemIndex(null);
  //   } catch (error) {
  //     console.error(error)
  //   }
  //   //Fill object with new values
  // };

  //Open edit/add mode
  // const toggleOpen = async (action, reload) => {
  //   setActionMode(action);

  //   if (action === null) {
  //     setSelectedItem(null);
  //     setSelectedItemIndex(null);
  //     // Restaurar la tabla de detalle al cerrar
  //     setDetailItems([
  //       {
  //         Id: 686,
  //         Codigo: "V03-202-3A",
  //         Plaza: "VILLA 03 PISO 2 APT 02 HAB 3 PLAZA A",
  //         Categoria: "EJECUTIVO",
  //         Estado: "PLAZA PENDIENTE SALIDA",
  //         Ocupante: "BELGICA GERALDINE CHIRINOS ACOSTA",
  //         FechaSalida: "28-04-2025",
  //         MotivoSalida: "ENTREGA VOLUNTARIA",
  //         ComentarioSalida: "SALIDA POR ENTREGA VOLUNTARIA EL 28-04-2025"
  //       },
  //       {
  //         Id: 703,
  //         Codigo: "E01-303-3A",
  //         Plaza: "EDIF. 01 PISO 3 APT 03 HAB 3 PLAZA A",
  //         Categoria: "EJECUTIVO",
  //         Estado: "PLAZA PENDIENTE SALIDA",
  //         Ocupante: "BENARDO RAMON D. ZIMMERMANN DIAZ",
  //         FechaSalida: "01-08-2025",
  //         MotivoSalida: "ENTREGA VOLUNTARIA",
  //         ComentarioSalida: "SALIDA POR ENTREGA VOLUNTARIA EL 01-08-2025"
  //       },
  //       {
  //         Id: 880,
  //         Codigo: "E08-501-4A",
  //         Plaza: "EDIF. 08 PISO 5 APT 01 HAB 4 PLAZA A",
  //         Categoria: "EJECUTIVO",
  //         Estado: "PLAZA PENDIENTE SALIDA",
  //         Ocupante: "CARLOS MARTIN LOPEZ",
  //         FechaSalida: "30-04-2025",
  //         MotivoSalida: "ENTREGA VOLUNTARIA",
  //         ComentarioSalida: "SALIDA POR ENTREGA VOLUNTARIA EL 30-04-2025"
  //       },
  //       {
  //         Id: 1016,
  //         Codigo: "E08-103-4A",
  //         Plaza: "EDIF. 08 PISO 1 APT 03 HAB 4 PLAZA A",
  //         Categoria: "EJECUTIVO",
  //         Estado: "DISPONIBLE PARA USO",
  //         Ocupante: "CHELSEA IRIS GARCIA BAEZ",
  //         FechaSalida: "28-06-2025",
  //         MotivoSalida: "BAJA",
  //         ComentarioSalida: "SALIDA POR BAJA EL 28-06-2025"
  //       }
  //     ]);
  //     setNewDetailItem({ campo1: '', campo2: '' });
  //     // Limpiar los campos de asignación
  //     setSelectedCodigo('');
  //     setSelectedNombre('');
  //     setSelectedGenero('');
  //     setSelectedFechaNac('');
  //     setSelectedEdad('');
  //     setSelectedTipo('');
  //     setSelectedCategoria('');
  //     setSelectedDepartamento('');
  //     setSelectedNivelPuesto('');
  //     setSelectedCargo('');
  //     setSelectedTipoVivienda('');
  //   }

  //   // Si estamos abriendo el modal en modo editar (U) o consultar (C)
  //   if ((action === "U" || action === "C") && selectedItem) {
  //     console.log("📝 Llenando campos con datos del registro seleccionado:", selectedItem);
      
  //     // Llenar los SelectBox con los valores del registro seleccionado
  //     setSelectedCodigo(selectedItem.Codigo || '');
  //     setSelectedNombre(selectedItem.Nombre || '');
  //     setSelectedGenero(selectedItem.Genero || '');
  //     setSelectedFechaNac(selectedItem.FechaNac || '');
  //     setSelectedEdad(selectedItem.Edad || '');
  //     setSelectedTipo(selectedItem.Tipo || '');
  //     setSelectedCategoria(selectedItem.Categoria || '');
  //     setSelectedDepartamento(selectedItem.Departamento || '');
  //     setSelectedNivelPuesto(selectedItem.NivelPuesto || '');
  //     setSelectedCargo(selectedItem.Cargo || '');
  //     setSelectedTipoVivienda(selectedItem.TipoVivienda || '');
  //   }

  //   if (action === "I") {
  //     setSelectedItem(null);
  //     setSelectedItemIndex(null);
  //   }

  //   if (selectedItemRef.current) {
  //     selectedItemRef.current.clearSelection();
  //   }

  //   setGeneralError(null);
  //   setOpen(!open);
  //   if (reload) {
  //     bindDataRemote();
  //   }
  // };

  const toggleOpen = async (action, reload) => {
    setActionMode(action);
  
    if (action === null) {
      setSelectedItem(null);
      setSelectedItemIndex(null);
      setIsMassiveCheckIn(false); // Resetear modo masivo
      // Restaurar la tabla de detalle al cerrar
      setDetailItems([]);
      setNewDetailItem({ campo1: '', campo2: '' });
      // Limpiar los campos de asignación
      setSelectedCodigo('');
      setSelectedNombre('');
      setSelectedGenero('');
      setSelectedFechaNac('');
      setSelectedEdad('');
      setSelectedTipo('');
      setSelectedCategoria('');
      setSelectedDepartamento('');
      setSelectedNivelPuesto('');
      setSelectedCargo('');
      setSelectedTipoVivienda('');
      // Limpiar campos del modal Check In
      setFechaCheckIn('');
      setComentarioCheckIn('');
      setValidationErrors({}); // Limpiar errores de validación
      // Limpiar campos de la plaza
      setPlazaCodigoCheckIn('');
      setPlazaNombreCheckIn('');
      setPlazaCategoriaCheckIn('');
      setPlazaEstadoCheckIn('');
    }
  
    // Si estamos abriendo el modal en modo editar (U) o consultar (C)
    if ((action === "U" || action === "C") && selectedItem) {
      console.log("📝 Llenando campos con datos del registro seleccionado:", selectedItem);
      
      // Llenar los SelectBox con los valores del registro seleccionado
      setSelectedCodigo(selectedItem.Codigo || '');
      setSelectedNombre(selectedItem.Nombre || '');
      setSelectedGenero(selectedItem.Genero || '');
      setSelectedFechaNac(selectedItem.FechaNac || '');
      setSelectedEdad(selectedItem.Edad || '');
      setSelectedTipo(selectedItem.Tipo || '');
      setSelectedCategoria(selectedItem.Categoria || '');
      setSelectedDepartamento(selectedItem.Departamento || '');
      setSelectedNivelPuesto(selectedItem.NivelPuesto || '');
      setSelectedCargo(selectedItem.Cargo || '');
      setSelectedTipoVivienda(selectedItem.TipoVivienda || '');
      
      // Establecer fecha actual por defecto para Check In
      if (action === "U") {
        const today = new Date().toISOString().split('T')[0];
        setFechaCheckIn(today);
      }
      
      // ⭐ COMENTADO: Ya no se necesita obtener plazas para Check In
      // if (selectedItem.Id) {
      //   await getPlazasDisponibles(selectedItem.Id);
      // } else {
      //   console.warn("⚠️ No se encontró Id en selectedItem");
      //   toast({
      //     type: "warning",
      //     message: "No se pudo identificar el colaborador seleccionado"
      //   });
      // }
    }
  
    if (action === "I") {
      setSelectedItem(null);
      setSelectedItemIndex(null);
    }
  
    if (selectedItemRef.current) {
      selectedItemRef.current.clearSelection();
    }
  
    setGeneralError(null);
    setOpen(!open);
    
    if (reload) {
      // Recargar datos después de guardar
      await getTableData();
    }
  };

  //Delete the record
  const deleteConfirm = async (obj) => {
    confirmAlert({
      closeOnClickOutside: false,
      message: "Seguro que quieres borrar este registro?",
      buttons: [
        {
          label: "Si",
          onClick: async () => {

            let prefix = idModule ? "CRUDDynamic" : "CRUD";
            let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}&RecordId=${selectedItem.GUID}${idModule ? "&IdModule=" + idModule : ""}`;
            await API.getAction(`api/${prefix}/Delete`, query);
            await bindDataRemote();
            setSelectedItem(null);
            setSelectedItemIndex(null);
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  // Función para imprimir el formulario (PrintForm)
  const handlePrintForm = async (item) => {
    try {
      console.log("🖨️ Iniciando impresión para item:", item);
      console.log("🔍 Campos disponibles en item:", Object.keys(item));
      
      // Extraer el IdOcupacion del item
      const idOcupacion = item.IdOcupacion || item.Id || "";
      console.log("🆔 IdOcupacion extraído:", idOcupacion);
      
      // Preparar los parámetros
      const jsonParams = {
        IdColaboradorList: "", // Vacío según requerimiento
        IdOcupacion: idOcupacion
      };
      
      console.log("📋 JSON Params:", jsonParams);
      
      const queryParams = new URLSearchParams({
        Token: user.Token,
        JsonParams: JSON.stringify(jsonParams),
        Accion: "FE"
      });
      
      // Usar la URL base configurada en Settings.APIPath
      const baseURL = Settings.APIPath.endsWith('/') 
        ? Settings.APIPath.slice(0, -1) 
        : Settings.APIPath;
      
      const url = `${baseURL}/api/OcupacionProcesos/OcupacionProcesoCheckInHelper?${queryParams.toString()}`;
      
      console.log("🔗 URL de impresión:", url);
      
      // Hacer la petición POST para obtener el HTML
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Error al obtener el reporte: ${response.status}`);
      }
      
      // Parsear el JSON de respuesta
      const jsonResponse = await response.json();
      console.log("✅ JSON Response:", jsonResponse);
      
      // Extraer el HTML del ReportData.HtmlText
      let htmlContent = '';
      
      if (Array.isArray(jsonResponse) && jsonResponse.length > 0) {
        // Si viene como array
        const firstItem = jsonResponse[0];
        
        if (firstItem.JSONData) {
          // Parsear JSONData si viene como string
          const parsedData = typeof firstItem.JSONData === 'string' 
            ? JSON.parse(firstItem.JSONData) 
            : firstItem.JSONData;
          
          console.log("📊 Parsed JSONData:", parsedData);
          
          // Extraer HtmlText desde ReportData (que es un array)
          if (parsedData.ReportData && Array.isArray(parsedData.ReportData) && parsedData.ReportData.length > 0) {
            htmlContent = parsedData.ReportData[0].HtmlText;
          } else if (parsedData.ReportData && parsedData.ReportData.HtmlText) {
            htmlContent = parsedData.ReportData.HtmlText;
          } else if (parsedData.JSONData && parsedData.JSONData.ReportData) {
            // Caso anidado
            if (Array.isArray(parsedData.JSONData.ReportData) && parsedData.JSONData.ReportData.length > 0) {
              htmlContent = parsedData.JSONData.ReportData[0].HtmlText;
            } else if (parsedData.JSONData.ReportData.HtmlText) {
              htmlContent = parsedData.JSONData.ReportData.HtmlText;
            }
          } else if (parsedData.HtmlText) {
            htmlContent = parsedData.HtmlText;
          }
        }
      } else if (jsonResponse.ReportData && jsonResponse.ReportData.HtmlText) {
        // Si viene directamente en ReportData
        htmlContent = jsonResponse.ReportData.HtmlText;
      } else if (jsonResponse.HtmlText) {
        // Si viene directamente como HtmlText
        htmlContent = jsonResponse.HtmlText;
      }
      
      if (!htmlContent) {
        console.error("❌ No se encontró HtmlText en la respuesta:", jsonResponse);
        throw new Error("No se encontró contenido HTML en la respuesta del servidor");
      }
      
      // Limpiar el HTML: eliminar escapes y saltos de línea escapados
      htmlContent = htmlContent
        .replace(/\\r\\n/g, '\n')      // Reemplazar \r\n escapados con saltos de línea reales
        .replace(/\\n/g, '\n')         // Reemplazar \n escapados
        .replace(/\\"/g, '"')          // Reemplazar \" con "
        .replace(/\\'/g, "'")          // Reemplazar \' con '
        .replace(/\\\\/g, '\\')        // Reemplazar \\ con \
        .trim();                       // Eliminar espacios al inicio y final
      
      // Modificar el CSS para evitar páginas en blanco: 
      // Solo aplicar page-break entre constancias, no después de la última
      htmlContent = htmlContent.replace(
        /\.constancia\s*{\s*page-break-after:\s*always;\s*}/g,
        '.constancia:not(:last-of-type) { page-break-after: always; }'
      );
      
      // Modificar @page para establecer márgenes en 0 (None)
      // Buscar la regla @page existente y reemplazar el margin
      if (htmlContent.includes('@page')) {
        htmlContent = htmlContent.replace(
          /@page\s*{\s*margin:\s*[^;]+;/g,
          '@page { margin: 0;'
        );
      } else {
        // Si no existe @page, agregarlo antes del cierre de </style>
        htmlContent = htmlContent.replace(
          '</style>',
          '@page { margin: 0; }\n  </style>'
        );
      }
      
      console.log("✅ HTML limpiado y configurado con márgenes 0, longitud:", htmlContent.length);
      console.log("🔍 Primeros 200 caracteres:", htmlContent.substring(0, 200));
      
      // Abrir una nueva ventana y escribir el HTML
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        
        // Esperar a que se cargue completamente y luego activar impresión
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
          }, 250);
        };
        
        console.log("✅ Reporte abierto en nueva ventana y listo para imprimir");
        
        toast({
          type: "success",
          message: "Reporte generado exitosamente"
        });

        // Hacer refresh para resetear el estado de edición
        await getTableData();
      } else {
        toast({
          type: "error",
          message: "No se pudo abrir la ventana de impresión. Por favor, habilita las ventanas emergentes."
        });
      }
      
    } catch (error) {
      console.error("❌ Error al imprimir:", error);
      toast({
        type: "error",
        message: `Error al generar el reporte: ${error.message}`
      });
    }
  };

  // Función para imprimir masivamente (múltiples ocupaciones seleccionadas)
  const handlePrintMassive = async () => {
    try {
      // Obtener los items seleccionados
      const selectedItems = getSelectedItems();
      
      if (selectedItems.length === 0) {
        toast({
          type: "warning",
          message: "Por favor, selecciona al menos una ocupación para imprimir"
        });
        return;
      }
      
      console.log("🖨️ Iniciando impresión masiva para items:", selectedItems);
      
      // Extraer los IdOcupacion de todos los items seleccionados
      const idOcupacionList = selectedItems
        .map(item => item.IdOcupacion || item.Id || "")
        .filter(id => id) // Filtrar IDs vacíos
        .join(',');
      
      console.log("🆔 IdOcupacionList extraído:", idOcupacionList);
      
      if (!idOcupacionList) {
        toast({
          type: "error",
          message: "No se pudieron obtener los IDs de las ocupaciones seleccionadas"
        });
        return;
      }
      
      // Preparar los parámetros
      const jsonParams = {
        idList: "" // Vacío según el formato de la URL
      };
      
      console.log("📋 JSON Params:", jsonParams);
      
      // Construir la URL con los parámetros
      const queryParams = new URLSearchParams({
        Token: user.Token,
        JsonParams: JSON.stringify(jsonParams),
        Accion: "FE",
        IdOcupacionList: idOcupacionList,
        Fecha: new Date().toISOString().split('T')[0] // Fecha actual en formato YYYY-MM-DD
      });
      
      // Usar la URL base configurada en Settings.APIPath
      const baseURL = Settings.APIPath.endsWith('/') 
        ? Settings.APIPath.slice(0, -1) 
        : Settings.APIPath;
      
      const url = `${baseURL}/api/OcupacionProcesos/OcupacionProcesoCheckInHelper?${queryParams.toString()}`;
      
      console.log("🔗 URL de impresión masiva:", url);
      
      // Hacer la petición POST para obtener el HTML
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Error al obtener el reporte: ${response.status}`);
      }
      
      // Parsear el JSON de respuesta
      const jsonResponse = await response.json();
      console.log("✅ JSON Response:", jsonResponse);
      
      // Extraer el HTML del ReportData.HtmlText
      let htmlContent = '';
      
      if (Array.isArray(jsonResponse) && jsonResponse.length > 0) {
        const firstItem = jsonResponse[0];
        
        if (firstItem.JSONData) {
          const parsedData = typeof firstItem.JSONData === 'string' 
            ? JSON.parse(firstItem.JSONData) 
            : firstItem.JSONData;
          
          console.log("📊 Parsed JSONData:", parsedData);
          
          if (parsedData.ReportData && Array.isArray(parsedData.ReportData) && parsedData.ReportData.length > 0) {
            htmlContent = parsedData.ReportData[0].HtmlText;
          } else if (parsedData.ReportData && parsedData.ReportData.HtmlText) {
            htmlContent = parsedData.ReportData.HtmlText;
          } else if (parsedData.JSONData && parsedData.JSONData.ReportData) {
            if (Array.isArray(parsedData.JSONData.ReportData) && parsedData.JSONData.ReportData.length > 0) {
              htmlContent = parsedData.JSONData.ReportData[0].HtmlText;
            } else if (parsedData.JSONData.ReportData.HtmlText) {
              htmlContent = parsedData.JSONData.ReportData.HtmlText;
            }
          } else if (parsedData.HtmlText) {
            htmlContent = parsedData.HtmlText;
          }
        }
      } else if (jsonResponse.ReportData && jsonResponse.ReportData.HtmlText) {
        htmlContent = jsonResponse.ReportData.HtmlText;
      } else if (jsonResponse.HtmlText) {
        htmlContent = jsonResponse.HtmlText;
      }
      
      if (!htmlContent) {
        console.error("❌ No se encontró HtmlText en la respuesta:", jsonResponse);
        throw new Error("No se encontró contenido HTML en la respuesta del servidor");
      }
      
      // Limpiar el HTML
      htmlContent = htmlContent
        .replace(/\\r\\n/g, '\n')
        .replace(/\\n/g, '\n')
        .replace(/\\"/g, '"')
        .replace(/\\'/g, "'")
        .replace(/\\\\/g, '\\')
        .trim();
      
      // Modificar el CSS para evitar páginas en blanco
      htmlContent = htmlContent.replace(
        /\.constancia\s*{\s*page-break-after:\s*always;\s*}/g,
        '.constancia:not(:last-of-type) { page-break-after: always; }'
      );
      
      // Modificar @page para establecer márgenes en 0
      if (htmlContent.includes('@page')) {
        htmlContent = htmlContent.replace(
          /@page\s*{\s*margin:\s*[^;]+;/g,
          '@page { margin: 0;'
        );
      } else {
        htmlContent = htmlContent.replace(
          '</style>',
          '@page { margin: 0; }\n  </style>'
        );
      }
      
      console.log("✅ HTML limpiado, longitud:", htmlContent.length);
      
      // Abrir una nueva ventana y escribir el HTML
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
          }, 250);
        };
        
      console.log("✅ Reporte masivo abierto en nueva ventana y listo para imprimir");
      
      toast({
        type: "success",
        message: `Reporte generado exitosamente para ${selectedItems.length} ocupacion(es)`
      });

      // Hacer refresh para resetear el estado de edición
      await getTableData();
    } else {
      toast({
        type: "error",
        message: "No se pudo abrir la ventana de impresión. Por favor, habilita las ventanas emergentes."
      });
    }
    
  } catch (error) {
    console.error("❌ Error al imprimir masivamente:", error);
    toast({
      type: "error",
      message: `Error al generar el reporte masivo: ${error.message}`
    });
  }
};

  // Función para abrir el modal de Check In Masivo
  const handleMassiveCheckIn = () => {
    // Obtener solo los items con CheckIn habilitado
    const selectedItems = getSelectedItemsWithCheckInEnabled();
    
    if (selectedItems.length === 0) {
      toast({
        type: "warning",
        message: "Por favor, selecciona al menos una ocupación con Check In habilitado"
      });
      return;
    }
    
    console.log("📝 Abriendo Check In Masivo para items con CheckIn habilitado:", selectedItems);
    
    // Activar modo masivo y abrir modal
    setIsMassiveCheckIn(true);
    setActionMode("U"); // Usar modo Update para activar los campos
    setOpen(true);
    
    // Establecer fecha actual por defecto
    const today = new Date().toISOString().split('T')[0];
    setFechaCheckIn(today);
    setComentarioCheckIn('');
    setValidationErrors({});
  };

  // Función para enviar respuesta del diálogo cuando se hace clic en "No"
  const handleDialogResponse = async (dialogText, dialogResp, accion) => {
    try {
      console.log("📝 Enviando respuesta del diálogo...");
      
      // Preparar los parámetros según la acción
      const jsonParams = {
        IdColaboradorList: ""
      };
      
      const queryParams = new URLSearchParams({
        Token: user.Token,
        JsonParams: JSON.stringify(jsonParams),
        IdOcupacion: selectedItem?.IdOcupacion || '',
        Accion: accion,
        DialogText: dialogText,
        DialogResp: dialogResp
      });
      
      // Agregar parámetros adicionales si es Check In
      if (accion === "PE") {
        queryParams.append('Comentario', comentarioCheckIn || '');
        queryParams.append('Fecha', fechaCheckIn);
      }
      
      // Usar la URL base configurada en Settings.APIPath
      const baseURL = Settings.APIPath.endsWith('/') 
        ? Settings.APIPath.slice(0, -1) 
        : Settings.APIPath;
      
      const url = `${baseURL}/api/OcupacionProcesos/OcupacionProcesoCheckInHelper?${queryParams.toString()}`;
      
      console.log("🔍 Query diálogo (No):", url);
      console.log("📤 Respuesta del diálogo:");
      console.log("  - DialogText:", dialogText);
      console.log("  - DialogResp:", dialogResp);
      
      // Hacer la petición POST
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const jsonResponse = await response.json();
        console.log("📥 Response del diálogo:", jsonResponse);
      }
      
    } catch (error) {
      console.error("❌ Error al enviar respuesta del diálogo:", error);
    }
  };

  // Función para guardar el Check In (similar a Asignación)
  const handleCheckInSubmit = async () => {
    // Limpiar errores previos
    setValidationErrors({});
    
    // Objeto para acumular errores
    const errors = {};
    
    // Validar que la fecha esté llena
    if (!fechaCheckIn) {
      errors.fechaCheckIn = "La fecha es obligatoria";
    }
    
    // Si hay errores, establecerlos y no continuar
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    
    // Mensaje diferente si es masivo
    const mensajeConfirmacion = isMassiveCheckIn 
      ? "¿Confirma que desea hacer el Check In para todos los colaboradores seleccionados?"
      : (!comentarioCheckIn.trim() 
          ? "¿Confirma que desea hacer el Check In sin indicar un Comentario?"
          : "¿Confirma que desea Procesar este Check-In?");
    
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui text-center p-4" style={{ 
            backgroundColor: 'white', 
            borderRadius: '10px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            minWidth: '400px'
          }}>
            <h6 className="mb-3 fw-normal fs-5">{mensajeConfirmacion}</h6>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <button
                className="btn btn-cancel-hover"
                onClick={async () => {
                  onClose();
                  // Enviar respuesta "No" al backend
                  await handleDialogResponse(mensajeConfirmacion, "No", "PE");
                }}
                style={{ width: '120px' }}
              >
                Cancelar
              </button>
              <button
                className="btn btn-success"
                onClick={async () => {
                  onClose();
                  // Verificar si es masivo o individual
                  if (isMassiveCheckIn) {
                    await handleCheckInMassiveSave(mensajeConfirmacion, "Si");
                  } else {
                    await handleCheckInSave(mensajeConfirmacion, "Si");
                  }
                }}
                style={{ width: '120px' }}
              >
                Confirmar
              </button>
            </div>
          </div>
        );
      }
    });
  };

  // Función para Release (Eliminar)
  const handleReleaseSubmit = async (item) => {
    const mensajeConfirmacion = "¿Confirma que desea Liberar esta Asignación?";
    
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui text-center p-4" style={{ 
            backgroundColor: 'white', 
            borderRadius: '10px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            minWidth: '400px'
          }}>
            <h6 className="mb-3 fw-normal fs-5">{mensajeConfirmacion}</h6>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <button
                className="btn btn-cancel-hover"
                onClick={async () => {
                  onClose();
                  // Enviar respuesta "No" al backend
                  await handleDialogResponse(mensajeConfirmacion, "No", "RE");
                }}
                style={{ width: '120px' }}
              >
                No
              </button>
              <button
                className="btn btn-success"
                onClick={async () => {
                  onClose();
                  // Enviar respuesta "Sí" y hacer el Release
                  await handleReleaseSave(item, mensajeConfirmacion, "Si");
                }}
                style={{ width: '120px' }}
              >
                Sí
              </button>
            </div>
          </div>
        );
      }
    });
  };

  // Función que realmente ejecuta el Release
  const handleReleaseSave = async (item, dialogText, dialogResp) => {
    try {
      console.log("🗑️ Liberando asignación...");
      
      // Preparar los parámetros
      const jsonParams = {
        IdColaboradorList: ""
      };
      
      const queryParams = new URLSearchParams({
        Token: user.Token,
        JsonParams: JSON.stringify(jsonParams),
        IdOcupacion: item.IdOcupacion,
        Accion: "RE",
        DialogText: dialogText,
        DialogResp: dialogResp
      });
      
      // Usar la URL base configurada en Settings.APIPath
      const baseURL = Settings.APIPath.endsWith('/') 
        ? Settings.APIPath.slice(0, -1) 
        : Settings.APIPath;
      
      const url = `${baseURL}/api/OcupacionProcesos/OcupacionProcesoCheckInHelper?${queryParams.toString()}`;
      
      console.log("🔗 URL de Release:", url);
      
      // Hacer la petición POST
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Error al liberar la asignación: ${response.status}`);
      }
      
      const jsonResponse = await response.json();
      console.log("✅ Response Release:", jsonResponse);
      
      // Verificar si hay error en la respuesta
      if (Array.isArray(jsonResponse) && jsonResponse.length > 0) {
        const firstItem = jsonResponse[0];
        if (firstItem.JSONData) {
          const parsedData = typeof firstItem.JSONData === 'string' 
            ? JSON.parse(firstItem.JSONData) 
            : firstItem.JSONData;
          
          if (parsedData.Error) {
            throw new Error(parsedData.Msg || "Error al liberar la asignación");
          }
        }
      }
      
      // Mostrar modal de éxito
      confirmAlert({
        closeOnClickOutside: false,
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui text-center p-4" style={{ 
              backgroundColor: 'white', 
              borderRadius: '10px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              minWidth: '400px'
            }}>
              <div className="mb-3">
                <i className="fa fa-check-circle" style={{ 
                  fontSize: '4rem', 
                  color: '#28a745' 
                }}></i>
              </div>
              <h6 className="mb-3 fw-medium fs-5">¡La Asignación fue liberada exitosamente!</h6>
              <p className="text-muted mb-4">
                El registro ha sido procesado correctamente.
              </p>
              <button
                className="btn btn-success"
                onClick={() => {
                  onClose();
                  // Recargar datos de la tabla
                  getTableData();
                }}
                style={{ width: '200px' }}
              >
                Continuar
              </button>
            </div>
          );
        }
      });
      
    } catch (error) {
      console.error("❌ Error al liberar asignación:", error);
      toast({
        type: "error",
        message: `Error al liberar: ${error.message}`
      });
    }
  };

  // Función para Release Masivo
  const handleMassiveRelease = () => {
    // Obtener solo los items con CheckIn habilitado
    const selectedItems = getSelectedItemsWithCheckInEnabled();
    
    if (selectedItems.length === 0) {
      toast({
        type: "warning",
        message: "Por favor, selecciona al menos una ocupación con Check In habilitado para liberar"
      });
      return;
    }
    
    console.log("🗑️ Iniciando Release Masivo para items con CheckIn habilitado:", selectedItems);
    
    const mensajeConfirmacion = "¿Confirma que desea Liberar todas estas asignaciones?";
    
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui text-center p-4" style={{ 
            backgroundColor: 'white', 
            borderRadius: '10px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            minWidth: '400px'
          }}>
            <h6 className="mb-3 fw-normal fs-5">{mensajeConfirmacion}</h6>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <button
                className="btn btn-cancel-hover"
                onClick={async () => {
                  onClose();
                  // Enviar respuesta "No" al backend
                  await handleDialogResponse(mensajeConfirmacion, "No", "RE");
                }}
                style={{ width: '120px' }}
              >
                No
              </button>
              <button
                className="btn btn-success"
                onClick={async () => {
                  onClose();
                  // Hacer el Release Masivo
                  await handleReleaseMassiveSave(selectedItems, mensajeConfirmacion, "Si");
                }}
                style={{ width: '120px' }}
              >
                Sí
              </button>
            </div>
          </div>
        );
      }
    });
  };

  // Función que realmente ejecuta el Release Masivo
  const handleReleaseMassiveSave = async (selectedItems, dialogText, dialogResp) => {
    try {
      console.log("🗑️ Liberando asignaciones masivamente (solo CheckIn habilitado)...");
      
      if (selectedItems.length === 0) {
        toast({
          type: "error",
          message: "No hay ocupaciones seleccionadas con Check In habilitado"
        });
        return;
      }
      
      // Extraer los IdOcupacion solo de items con CheckIn habilitado
      const idOcupacionList = selectedItems
        .map(item => item.IdOcupacion || item.Id || "")
        .filter(id => id)
        .join(',');
      
      console.log("🆔 IdOcupacionList para Release Masivo (solo CheckIn habilitado):", idOcupacionList);
      
      if (!idOcupacionList) {
        toast({
          type: "error",
          message: "No se pudieron obtener los IDs de las ocupaciones seleccionadas"
        });
        return;
      }
      
      // Preparar los parámetros
      const jsonParams = {
        IdColaboradorList: ""
      };
      
      const queryParams = new URLSearchParams({
        Token: user.Token,
        JsonParams: JSON.stringify(jsonParams),
        IdOcupacionList: idOcupacionList,
        Accion: "RE",
        DialogText: dialogText,
        DialogResp: dialogResp
      });
      
      // Usar la URL base configurada en Settings.APIPath
      const baseURL = Settings.APIPath.endsWith('/') 
        ? Settings.APIPath.slice(0, -1) 
        : Settings.APIPath;
      
      const url = `${baseURL}/api/OcupacionProcesos/OcupacionProcesoCheckInHelper?${queryParams.toString()}`;
      
      console.log("🔗 URL de Release Masivo:", url);
      
      // Hacer la petición POST
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Error al liberar las asignaciones: ${response.status}`);
      }
      
      const jsonResponse = await response.json();
      console.log("✅ Response Release Masivo:", jsonResponse);
      
      // Verificar si hay error en la respuesta
      if (Array.isArray(jsonResponse) && jsonResponse.length > 0) {
        const firstItem = jsonResponse[0];
        if (firstItem.JSONData) {
          const parsedData = typeof firstItem.JSONData === 'string' 
            ? JSON.parse(firstItem.JSONData) 
            : firstItem.JSONData;
          
          if (parsedData.Error) {
            throw new Error(parsedData.Msg || "Error al liberar las asignaciones");
          }
        }
      }
      
      // Mostrar modal de éxito
      confirmAlert({
        closeOnClickOutside: false,
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui text-center p-4" style={{ 
              backgroundColor: 'white', 
              borderRadius: '10px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              minWidth: '400px'
            }}>
              <div className="mb-3">
                <i className="fa fa-check-circle" style={{ 
                  fontSize: '4rem', 
                  color: '#28a745' 
                }}></i>
              </div>
              <h6 className="mb-3 fw-medium fs-5">¡Las Asignaciones fueron liberadas exitosamente!</h6>
              <p className="text-muted mb-4">
                Se procesaron {selectedItems.length} ocupacion(es) correctamente.
              </p>
              <button
                className="btn btn-success"
                onClick={() => {
                  onClose();
                  // Recargar datos de la tabla
                  getTableData();
                }}
                style={{ width: '200px' }}
              >
                Continuar
              </button>
            </div>
          );
        }
      });
      
    } catch (error) {
      console.error("❌ Error al liberar asignaciones masivamente:", error);
      toast({
        type: "error",
        message: `Error al liberar: ${error.message}`
      });
    }
  };

  // Función que realmente guarda el Check In
  const handleCheckInSave = async (dialogText, dialogResp) => {
    try {
      console.log("💾 Guardando Check In...");
      
      // Validar que selectedItem exista
      if (!selectedItem || !selectedItem.IdOcupacion) {
        toast({
          type: "error",
          message: "No se pudo identificar el registro seleccionado. Por favor, intente nuevamente."
        });
        return;
      }
      
      // Preparar los parámetros
      const jsonParams = {
        IdColaboradorList: ""
      };
      
      const queryParams = new URLSearchParams({
        Token: user.Token,
        JsonParams: JSON.stringify(jsonParams),
        IdOcupacion: selectedItem.IdOcupacion,
        Accion: "PE",
        Comentario: comentarioCheckIn || '',
        Fecha: fechaCheckIn,
        DialogText: dialogText,
        DialogResp: dialogResp
      });
      
      // Usar la URL base configurada en Settings.APIPath
      const baseURL = Settings.APIPath.endsWith('/') 
        ? Settings.APIPath.slice(0, -1) 
        : Settings.APIPath;
      
      const url = `${baseURL}/api/OcupacionProcesos/OcupacionProcesoCheckInHelper?${queryParams.toString()}`;
      
      console.log("🔗 URL de Check In:", url);
      
      // Hacer la petición POST
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Error al guardar el Check In: ${response.status}`);
      }
      
      const jsonResponse = await response.json();
      console.log("✅ Response Check In:", jsonResponse);
      
      // Verificar si hay error en la respuesta
      if (Array.isArray(jsonResponse) && jsonResponse.length > 0) {
        const firstItem = jsonResponse[0];
        if (firstItem.JSONData) {
          const parsedData = typeof firstItem.JSONData === 'string' 
            ? JSON.parse(firstItem.JSONData) 
            : firstItem.JSONData;
          
          if (parsedData.Error) {
            throw new Error(parsedData.Msg || "Error al guardar el Check In");
          }
        }
      }
      
      // Mostrar modal de éxito
      confirmAlert({
        closeOnClickOutside: false,
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui text-center p-4" style={{ 
              backgroundColor: 'white', 
              borderRadius: '10px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              minWidth: '400px'
            }}>
              <div className="mb-3">
                <i className="fa fa-check-circle" style={{ 
                  fontSize: '4rem', 
                  color: '#28a745' 
                }}></i>
              </div>
              <h6 className="mb-3 fw-medium fs-5">¡El Check In fue realizado exitosamente!</h6>
              <p className="text-muted mb-4">
                El registro ha sido guardado correctamente.
              </p>
              <button
                className="btn btn-success"
                onClick={() => {
                  onClose();
                  // Cerrar modal y recargar datos
                  toggleOpen(null, true);
                }}
                style={{ width: '200px' }}
              >
                Continuar
              </button>
            </div>
          );
        }
      });
      
    } catch (error) {
      console.error("❌ Error al guardar Check In:", error);
      toast({
        type: "error",
        message: `Error al guardar: ${error.message}`
      });
    }
  };

  // Función que guarda el Check In Masivo
  const handleCheckInMassiveSave = async (dialogText, dialogResp) => {
    try {
      console.log("💾 Guardando Check In Masivo...");
      
      // Obtener solo los items seleccionados con CheckIn habilitado
      const selectedItems = getSelectedItemsWithCheckInEnabled();
      
      if (selectedItems.length === 0) {
        toast({
          type: "error",
          message: "No hay ocupaciones seleccionadas con Check In habilitado"
        });
        return;
      }
      
      // Extraer los IdOcupacion solo de items con CheckIn habilitado
      const idOcupacionList = selectedItems
        .map(item => item.IdOcupacion || item.Id || "")
        .filter(id => id)
        .join(',');
      
      console.log("🆔 IdOcupacionList para Check In Masivo (solo CheckIn habilitado):", idOcupacionList);
      
      if (!idOcupacionList) {
        toast({
          type: "error",
          message: "No se pudieron obtener los IDs de las ocupaciones seleccionadas"
        });
        return;
      }
      
      // Preparar los parámetros
      const jsonParams = {
        IdColaboradorList: ""
      };
      
      const queryParams = new URLSearchParams({
        Token: user.Token,
        JsonParams: JSON.stringify(jsonParams),
        IdOcupacionList: idOcupacionList,
        Accion: "PE",
        Comentario: comentarioCheckIn || '',
        Fecha: fechaCheckIn,
        DialogText: dialogText,
        DialogResp: dialogResp
      });
      
      // Usar la URL base configurada en Settings.APIPath
      const baseURL = Settings.APIPath.endsWith('/') 
        ? Settings.APIPath.slice(0, -1) 
        : Settings.APIPath;
      
      const url = `${baseURL}/api/OcupacionProcesos/OcupacionProcesoCheckInHelper?${queryParams.toString()}`;
      
      console.log("🔗 URL de Check In Masivo:", url);
      
      // Hacer la petición POST
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Error al guardar el Check In Masivo: ${response.status}`);
      }
      
      const jsonResponse = await response.json();
      console.log("✅ Response Check In Masivo:", jsonResponse);
      
      // Verificar si hay error en la respuesta
      if (Array.isArray(jsonResponse) && jsonResponse.length > 0) {
        const firstItem = jsonResponse[0];
        if (firstItem.JSONData) {
          const parsedData = typeof firstItem.JSONData === 'string' 
            ? JSON.parse(firstItem.JSONData) 
            : firstItem.JSONData;
          
          if (parsedData.Error) {
            throw new Error(parsedData.Msg || "Error al guardar el Check In Masivo");
          }
        }
      }
      
      // Mostrar modal de éxito
      confirmAlert({
        closeOnClickOutside: false,
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui text-center p-4" style={{ 
              backgroundColor: 'white', 
              borderRadius: '10px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              minWidth: '400px'
            }}>
              <div className="mb-3">
                <i className="fa fa-check-circle" style={{ 
                  fontSize: '4rem', 
                  color: '#28a745' 
                }}></i>
              </div>
              <h6 className="mb-3 fw-medium fs-5">¡El Check In fue realizado exitosamente!</h6>
              <p className="text-muted mb-4">
                Se procesaron {selectedItems.length} ocupacion(es) correctamente.
              </p>
              <button
                className="btn btn-success"
                onClick={() => {
                  onClose();
                  // Cerrar modal y recargar datos
                  setIsMassiveCheckIn(false);
                  toggleOpen(null, true);
                }}
                style={{ width: '200px' }}
              >
                Continuar
              </button>
            </div>
          );
        }
      });
      
    } catch (error) {
      console.error("❌ Error al guardar Check In Masivo:", error);
      toast({
        type: "error",
        message: `Error al guardar: ${error.message}`
      });
    }
  };

  //Update the field value on formik according to what has been updated
  const updateField = (fieldName, fieldValue) => {
    formik.setFieldValue(fieldName, fieldValue);
  };



  const [validationsSchema, setValidationSchema] = useState(null);

  const fillFormikObject = (record) => {
    //debugger;
    console.log("record", record, "model", section);
    if (
      section &&
      fields &&
      fields.length > 0
    ) {
      fields.forEach((item) => {
        console.log(
          "field name",
          item.FieldName,
          "RecordValue ",
          record[item.FieldName]
        );
        formik.setFieldValue(item.FieldName, record[item.FieldName]);
      });
    }

    //Now
  };

  const prepareFormikObject = () => {
    // console.log("Preparing formik object", section)
    let initialObject = {};
    let initialObjectValidation = {};

    if (fields) {
      fields.forEach((item) => {
        initialObject[item.FieldName] = item.value;

        if (item.Required) {
          initialObjectValidation[item.FieldName] = yupTypeValidator(item);
        }
      });
    }
    formik.initialValues = initialObject;

    console.log("initialObject", initialObject)

    setValidationSchema(yup.object(initialObjectValidation));
    //Now
  };

  //This method is to save the record we are working on
  const handleSubmit = async (obj, event) => {
    console.log("❗ ~ file: CRUDSimple.js:259 ~ handleSubmit ~ obj:", obj)
    console.log({ fields: fields })
    let actions = {
      "I": "I",
      "U": "U",
      "D": "I"
    };

    if (actionMode === "D") {
      const { GUID, Id, ...rest } = obj;
      obj = rest;
    }


    confirmAlert({
      closeOnClickOutside: false,
      message: "Estas seguro de querer guardar este registro?",
      buttons: [
        {
          label: "Si",
          onClick: async () => {
            let objSPVersion = "";
            fields.forEach((item) => {

              if (item.ReadOnly || item.HtmlType === "separator") return;

              if (item.HtmlType !== "separator") {
                objSPVersion +=
                  (objSPVersion.length > 0 ? ", " : "") + `@${item.FieldName}=`;
              }
              if (
                item.FieldType === "int" ||
                item.FieldType === "bool" ||
                item.FieldType === "bit" ||
                item.FieldType === "bigint"
              ) {
                objSPVersion +=
                  obj[item.FieldName] === undefined || obj[item.FieldName] === null
                    ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                    : "'" + obj[item.FieldName] + "'";

              } else if (item.HtmlType === "password") {
                let passwordEncrypted = null;
                if (obj[item.FieldName] && obj[item.FieldName].length > 0) {
                  passwordEncrypted =
                    obj["UserName"].toUpperCase() + obj[item.FieldName];
                  passwordEncrypted = Sha256.hash(passwordEncrypted);
                  ;
                }
                objSPVersion +=
                  obj[item.FieldName] === undefined
                    ? "null"
                    : "'" + passwordEncrypted + "'"
              } else
                if (item.HtmlType === 'radio') {

                  objSPVersion +=
                    obj[item.FieldName] === undefined || obj[item.FieldName] === null
                      ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                      : "'" + obj[item.FieldName] + "'";
                } else {
                  objSPVersion +=
                    obj[item.FieldName] === undefined || obj[item.FieldName] === null
                      ? "null"
                      : "'" + obj[item.FieldName] + "'";
                }
            });

            let queryString = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}&ActionMode=${actions[actionMode]}${idModule ? "&IdModule=" + idModule : ""}`;
            let queryData = {
              Data: objSPVersion,
            };

            let prefix = idModule ? "CRUDDynamic" : "CRUD";
            let request = await API.postAction(
              `api/${prefix}/AddEdit?${queryString}`,
              queryData
            );

            if (request.status === 200) {
              let response = JSON.parse(request.data[0].JSONData)[0];
              //debugger;
              if (response.Error) {
                setGeneralError(response.Msg);
                return;
              }
            }
            setGeneralError(null);
            setSelectedItem(null);
            setSelectedItemIndex(null);

            formik.resetForm();

            toast({
              type: "success",
              "message": "Registro guardado correctamente",
            })
            toggleOpen(null, true);
          },
        },
        {
          label: "No",
        },
      ],
    });


  };

  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,

    validateOnChange: false,
    validateOnBlur: false,

    validationSchema: validationsSchema,
    onSubmit: handleSubmit,
  });


  const addFavorite = async () => {

    const newFavorite = {
      icon: `${section.FormIcon}`,
      path: pathname,
      formPath: section.FormPath,
      title: section.FormTitle,
    }
    UpdateFavorites(newFavorite)

  }

  const headerWithoutAuditFields = () => {
    // Para reportes, usar Fields del Model si tableHeader está vacío
    let headers = tableHeader && tableHeader.length > 0 ? tableHeader : fields;
    
    // Normalizar headers para que tengan FieldTitle (reportes usan ListTitle)
    const normalizedHeaders = headers && headers.map(header => ({
      ...header,
      FieldTitle: header.FieldTitle || header.ListTitle || header.FieldName
    }));
    
    return normalizedHeaders && normalizedHeaders
      .filter(x =>
        x.FieldTitle !== "Audit Information"
        && x.FieldName !== "Id"
        && x.FieldName !== "IdUserAdd"
        && x.FieldName !== 'DateAdd'
        && x.FieldName !== 'IdUserMod'
        && x.FieldName !== 'DateMod'
        && (x.ListVisible !== false) // Solo mostrar si ListVisible no es false
      );
  }

  // Función helper para obtener la alineación de una columna
  const getColumnAlignment = (columnName) => {
    // Primero intentar buscar en fields (que es donde están los datos del Model)
    if (fields && fields.length > 0) {
      const field = fields.find(f => f.FieldName === columnName);
      if (field?.Alignment) {
        return field.Alignment;
      }
    }
    
    // Si no está en fields, intentar en model.data.Columns
    if (model?.data?.Columns && model.data.Columns.length > 0) {
      const column = model.data.Columns.find(c => c.FieldName === columnName);
      if (column?.Alignment) {
        return column.Alignment;
      }
    }
    
    // Alineación por defecto
    return 'left';
  }

  // Función helper para convertir alignment a clase de Bootstrap justify-content para HEADERS
  const getHeaderJustifyClass = (alignment) => {
    switch(alignment) {
      case 'left':
        return 'justify-content-start';
      case 'center':
        return 'justify-content-center';
      case 'right':
        return 'justify-content-end';
      default:
        return 'justify-content-start';
    }
  }

  // Modified by Frandy para exportar solo las columnas visibles
  const exportToExcel = useCallback(async () => {

    const visibleColumns = headerWithoutAuditFields();
    
    const excelData = model.data.Rows && model.data.Rows.map((item, rowIndex) => {
      return visibleColumns.reduce((acc, column) => {
        const isCheckboxColumn = column.FieldName === 'Ok' || 
                                 column.FieldTitle?.toLowerCase().includes('selección') ||
                                 column.FieldTitle?.toLowerCase().includes('seleccion');
        
        // Para columnas de checkbox, usar el estado de selectedCheckboxes
        if (isCheckboxColumn || typeof item[column.FieldName] === 'boolean') {
          acc[column.FieldName] = selectedCheckboxes[rowIndex] ? 'Sí' : 'No';
        } else {
          const cellValue = item[column.FieldName];
          
          // Intentar parsear si es un string JSON con array de iconos
          let parsedIcons = null;
          if (typeof cellValue === 'string' && (cellValue.trim().startsWith('[') || cellValue.trim().startsWith('{'))) {
            try {
              // Limpiar el JSON: eliminar comas antes de ] o }
              let cleanedJson = cellValue
                .replace(/,(\s*[\]}])/g, '$1') // Eliminar comas antes de ] o }
                .replace(/\r\n/g, '') // Eliminar saltos de línea \r\n
                .replace(/\n/g, ''); // Eliminar saltos de línea \n
              
              parsedIcons = JSON.parse(cleanedJson);
            } catch (e) {
              // Si falla el parseo, continuar con el flujo normal
            }
          }
          
          // Si logramos parsear un array de iconos estructurados
          if (Array.isArray(parsedIcons) && parsedIcons.length > 0 && parsedIcons[0].icon) {
            // Mostrar los nombres de los iconos habilitados
            const enabledIcons = parsedIcons
              .filter(icon => icon.Enabled !== "false" && icon.Enabled !== false)
              .map(icon => icon.Name || icon.function)
              .join(', ');
            acc[column.FieldName] = enabledIcons || '●'.repeat(parsedIcons.length);
          }
          // Formato antiguo: Para iconos en Excel, mostrar un símbolo o texto alternativo
          else if (typeof cellValue === 'string' && (cellValue.includes('fa-') || cellValue.includes('icon-'))) {
            // Contar cuántos iconos hay (buscar cuántas veces aparece "fa fa-" o "fas fa-" etc)
            const iconCount = (cellValue.match(/fa[srbl]?\s+fa-/g) || []).length;
            acc[column.FieldName] = '●'.repeat(Math.max(1, iconCount));
          } else {
            acc[column.FieldName] = cellValue;
          }
        }
        return acc;
      }, {});

    });
  
    GenerateXLS(excelData, `${section.FormTitle}.xlsx`);

  }, [model.data.Rows, tableHeader, section, selectedCheckboxes]);

  const exportToPDF = useCallback(async () => {
    const container = document.getElementById("contentContainer");
    if (container) {
      await GeneratePDF(container, "landscape", section?.FormTitle || "Registro");
    } else {
      console.error("No se encontró el contenedor para exportar a PDF");
      alert("Error: No se puede exportar el contenido. Elemento no encontrado.");
    }
    // GeneratePDF(container);
  }, [section])

  // Add by Victor: Agrega el handlePrint para imprimir el contenido de la pantalla
  const handlePrint = useCallback(() => {
    // Crear el HTML de la tabla
    const visibleColumns = headerWithoutAuditFields();
    
    let tableHTML = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>${section?.FormTitle || 'Tabla'}</title>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
          <style>
            @media print {
              @page {
                margin: 1cm;
                size: landscape;
              }
            }
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            h4 {
              text-align: center;
              font-weight: bold;
              margin-bottom: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              border: 1px solid #000;
            }
            th {
              background-color: #6c757d;
              color: white;
              font-weight: bold;
              padding: 8px;
              border: 1px solid #000;
              text-align: left;
            }
            td {
              padding: 8px;
              border: 1px solid #000;
            }
            tr:nth-child(even) {
              background-color: #f2f2f2;
            }
          </style>
        </head>
        <body>
          <h4>${section?.FormTitle || 'Tabla'}</h4>
          <table>
            <thead>
              <tr>
                ${visibleColumns.map(column => {
                  return `<th style="text-align: center;">${column.FieldTitle}</th>`;
                }).join('')}
              </tr>
            </thead>
            <tbody>
              ${model?.data?.Rows?.map((item, rowIndex) => {
                return `<tr>
                  ${visibleColumns.map((column) => {
                    const alignment = getColumnAlignment(column.FieldName);
                    const isCheckboxColumn = column.FieldName === 'Ok' || 
                                             column.FieldTitle?.toLowerCase().includes('selección') ||
                                             column.FieldTitle?.toLowerCase().includes('seleccion');
                    
                    let cellValue = '';
                    let cellAlignment = alignment;
                    
                    if (column.FieldType === "datetime" || column.FieldType === "date") {
                      cellValue = moment(item[column.FieldName]).format("MM/DD/YYYY");
                    } else if (isCheckboxColumn || typeof item[column.FieldName] === 'boolean') {
                      // Usar el estado de selectedCheckboxes para columnas de selección
                      cellValue = selectedCheckboxes[rowIndex] ? 'Sí' : 'No';
                    } else {
                      const rawValue = item[column.FieldName] || '';
                      
                      // Intentar parsear si es un string JSON con array de iconos
                      let parsedIcons = null;
                      if (typeof rawValue === 'string' && (rawValue.trim().startsWith('[') || rawValue.trim().startsWith('{'))) {
                        try {
                          // Limpiar el JSON: eliminar comas antes de ] o }
                          let cleanedJson = rawValue
                            .replace(/,(\s*[\]}])/g, '$1') // Eliminar comas antes de ] o }
                            .replace(/\r\n/g, '') // Eliminar saltos de línea \r\n
                            .replace(/\n/g, ''); // Eliminar saltos de línea \n
                          
                          parsedIcons = JSON.parse(cleanedJson);
                        } catch (e) {
                          // Si falla el parseo, continuar con el flujo normal
                        }
                      }
                      
                      // Si logramos parsear un array de iconos estructurados
                      if (Array.isArray(parsedIcons) && parsedIcons.length > 0 && parsedIcons[0].icon) {
                        cellValue = parsedIcons.map(iconObj => {
                          const isDisabled = iconObj.Enabled === "false" || iconObj.Enabled === false;
                          const opacity = isDisabled ? 0.3 : 1;
                          const color = isDisabled ? '#ccc' : '#000';
                          return `<i class="${iconObj.icon}" style="font-size: 1.2rem; margin: 0 10px; cursor: pointer; color: ${color}; opacity: ${opacity};" title="${iconObj.Name || ''}"></i>`;
                        }).join('');
                        cellAlignment = 'center'; // Centralizar iconos
                      }
                      // Formato antiguo: Detectar si el valor es un icono (string)
                      else if (typeof rawValue === 'string' && (rawValue.includes('fa-') || rawValue.includes('icon-'))) {
                        // Dividir múltiples iconos si existen
                        const iconClasses = rawValue.split(/\s+(?=fa[srbl]?\s+fa-)/);
                        cellValue = iconClasses.map(iconClass => {
                          return `<i class="${iconClass.trim()}" style="font-size: 1.2rem; margin: 0 10px; cursor: pointer; color: #000;"></i>`;
                        }).join('');
                        cellAlignment = 'center'; // Centralizar iconos
                      } else {
                        cellValue = rawValue;
                      }
                    }
                    return `<td style="text-align: ${cellAlignment};">${cellValue}</td>`;
                  }).join('')}
                </tr>`;
              }).join('') || ''}
            </tbody>
            ${model?.data?.Summary && model.data.Summary.length > 0 ? `
              <tfoot>
                <tr style="background-color: #e9ecef; font-weight: bold;">
                  ${visibleColumns.map((column) => {
                    const summaryItem = model.data.Summary.find(s => s.ColumnName === column.FieldName);
                    const alignment = getColumnAlignment(column.FieldName);
                    const summaryAlign = alignment === 'right' ? 'right' : 'center';
                    return `<td style="font-weight: bold; text-align: ${summaryAlign};">${summaryItem ? summaryItem.SummValue.toLocaleString('en-US') : ''}</td>`;
                  }).join('')}
                </tr>
              </tfoot>
            ` : ''}
          </table>
        </body>
      </html>
    `;

    // Crear una nueva ventana y escribir el HTML
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(tableHTML);
      printWindow.document.close();
      
      // Esperar a que se cargue el contenido y luego imprimir
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print();
          // Cerrar la ventana después de imprimir (opcional)
          // printWindow.close();
        }, 250);
      };
    }
  }, [model?.data?.Rows, tableHeader, section])

  // END METHODS

  // UI METHODS

  // REMOVIDO: bindDataRemote ya tiene sortBy y sortByOrder en sus dependencias del useCallback
  // useEffect(() => {
  //   console.log("entro", new Date())
  //   bindDataRemote();
  // }, [sortBy, sortByOrder])

  const loadGRIDUI = () => {
    return (
      <>
      
        <Container>
          <Row className="mx-2">

            <Table hover size="xl" bordered className="border shadow-sm" >
              <thead className="table-secondary">
                <tr>
                  {headerWithoutAuditFields()
                    .map((item, index) => {
                      const alignment = getColumnAlignment(item.FieldName);
                      const justifyClass = getHeaderJustifyClass(alignment);
                      
                      // Si la columna es de tipo checkbox (Ok, Selección, etc.), mostrar checkbox de seleccionar todos
                      const isCheckboxColumn = item.FieldName === 'Ok' || 
                                               item.FieldTitle?.toLowerCase().includes('selección') ||
                                               item.FieldTitle?.toLowerCase().includes('seleccion');
                      
                      return (
                        <th key={index} className={`fw-bold`} style={{ textAlign: alignment }}>
                          <div className={`d-flex ${isCheckboxColumn ? 'justify-content-center' : justifyClass} align-items-center`}>
                            {isCheckboxColumn ? (
                              <div className="d-flex flex-column align-items-center justify-content-center">
                                <input 
                                  type="checkbox" 
                                  checked={selectAll}
                                  onChange={handleSelectAll}
                                  className="form-check-input mb-2"
                                  style={{ cursor: 'pointer' }}
                                />
                                <span>{item.FieldTitle}</span>
                              </div>
                            ) : (
                            <span 
                              className="clickable"
                              onClick={() => {
                                setSortBy(item.FieldName);
                                if (item.FieldName === sortBy) {
                                  if (sortByOrder === 'ASC') {
                                    setSortByOrder('DESC')
                                  } else {
                                    setSortByOrder('ASC')
                                  }
                                } else {
                                  setSortByOrder('ASC')
                                }
                              }}
                            >
                              {item.FieldTitle} 
                              {sortBy === item.FieldName && sortByOrder === 'ASC' ? 
                                <i className="fas fa-sort-up ms-1"></i> : 
                                sortBy === item.FieldName && sortByOrder === 'DESC' ? 
                                <i className="fas fa-sort-down ms-1"></i> : null
                              }
                            </span>
                            )}
                          </div>
                        </th>
                      )
                    })}
                </tr>
              </thead>
              <tbody>
                {model?.data && model.data.Rows.map((item, index) => {
                  return (
                    <tr 
                      key={index} 
                      onClick={() => { 
                        setSelectedItem(item);
                        setSelectedItemIndex(index);
                      }} 
                      className={selectedItemIndex === index ? "active" : ""}
                    >
                      {headerWithoutAuditFields()
                        .map((column, index2) => {
                          const alignment = getColumnAlignment(column.FieldName);
                          
                          if (column.FieldType === "datetime" || column.FieldType === "date") {
                            return (
                              <td key={index2} className={` `} style={{ textAlign: alignment }}>{moment(item[column.FieldName]).format("MM/DD/YYYY")}</td>
                            )
                          }

                          // Si es una columna de checkbox (Ok, Selección, etc.)
                          const isCheckboxColumn = column.FieldName === 'Ok' || 
                                                   column.FieldTitle?.toLowerCase().includes('selección') ||
                                                   column.FieldTitle?.toLowerCase().includes('seleccion');
                          
                          if (isCheckboxColumn || typeof item[column.FieldName] === 'boolean') {
                          return (
                              <td key={index2} style={{ textAlign: alignment }}>
                                <div className="d-flex justify-content-center align-items-center">
                                  <input 
                                    type="checkbox" 
                                    checked={selectedCheckboxes[index] || false}
                                    onChange={(e) => {
                                      e.stopPropagation(); // Evitar que el click en el checkbox seleccione la fila
                                      handleCheckboxToggle(index);
                                    }}
                                    className="form-check-input"
                                    style={{ cursor: 'pointer' }}
                                  />
                                </div>
                              </td>
                            )
                          }

                          // Detectar si el valor es un icono (contiene "fa fa-" o "fas fa-" o similar)
                          const cellValue = item[column.FieldName];
                          
                          // Intentar parsear si es un string JSON con array de iconos
                          let parsedIcons = null;
                          if (typeof cellValue === 'string' && (cellValue.trim().startsWith('[') || cellValue.trim().startsWith('{')) ) {
                            try {
                              // Limpiar el JSON: eliminar comas antes de ] o }
                              let cleanedJson = cellValue
                                .replace(/,(\s*[\]}])/g, '$1') // Eliminar comas antes de ] o }
                                .replace(/\r\n/g, '') // Eliminar saltos de línea \r\n
                                .replace(/\n/g, ''); // Eliminar saltos de línea \n
                              
                              console.log(`🧹 JSON limpiado para ${column.FieldName}:`, cleanedJson);
                              parsedIcons = JSON.parse(cleanedJson);
                              console.log(`✅ JSON parseado para columna ${column.FieldName}:`, parsedIcons);
                            } catch (e) {
                              // Si falla el parseo, continuar con el flujo normal
                              console.warn(`⚠️ No se pudo parsear el JSON de iconos para ${column.FieldName}:`, cellValue, e);
                            }
                          }
                          
                          // Si logramos parsear un array de iconos estructurados
                          if (Array.isArray(parsedIcons) && parsedIcons.length > 0 && parsedIcons[0].icon) {
                            console.log(`🎨 Renderizando ${parsedIcons.length} iconos para ${column.FieldName}`);
                            return (
                              <td key={index2} style={{ textAlign: 'center' }}>
                                <div className="d-flex justify-content-center align-items-center gap-3">
                                  {parsedIcons.map((iconObj, iconIdx) => {
                                    const isDisabled = iconObj.Enabled === "false" || iconObj.Enabled === false;
                                    const iconClass = iconObj.icon;
                                    const isCheckInIcon = iconObj.function === 'CheckIn' || iconObj.Name === 'CheckIn';
                                    const isPrintIcon = iconObj.function === 'PrintForm' || iconObj.Name === 'PrintForm';
                                    const isReleaseIcon = iconObj.function === 'Release' || iconObj.Name === 'Release';
                                    
                                    return (
                                      <i 
                                        key={iconIdx} 
                                        className={iconClass} 
                                        style={{ 
                                          fontSize: '1.2rem', 
                                          cursor: isDisabled ? 'not-allowed' : 'pointer', 
                                          color: isDisabled ? '#ccc' : '#000',
                                          opacity: isDisabled ? 0.5 : 1
                                        }}
                                        onClick={!isDisabled ? (e) => {
                                          e.stopPropagation();
                                          
                                          if (isPrintIcon) {
                                            // Función de imprimir - Actualizar foco visual
                                            setSelectedItem(item);
                                            setSelectedItemIndex(index);
                                            handlePrintForm(item);
                                          } else if (isCheckInIcon) {
                                            // Función de Check In
                                            console.log("📋 Item seleccionado para Check In:", item);
                                            console.log("📋 Campos disponibles:", Object.keys(item));
                                            console.log("📋 IdOcupacion:", item.IdOcupacion);
                                            
                                            // Validar que el item tenga IdOcupacion
                                            if (!item.IdOcupacion) {
                                              toast({
                                                type: "error",
                                                message: "No se encontró el identificador de ocupación. Por favor, consulte nuevamente."
                                              });
                                              return;
                                            }
                                            
                                            // Establecer item y actualizar el foco visual
                                            setSelectedItem(item);
                                            setSelectedItemIndex(index);
                                            
                                            const today = new Date().toISOString().split('T')[0];
                                            setFechaCheckIn(today);
                                            setComentarioCheckIn('');
                                            
                                            setSelectedCodigo(item.Codigo || '');
                                            setSelectedNombre(item.Nombre || '');
                                            setSelectedGenero(item.Genero || '');
                                            setSelectedFechaNac(item.FechaNac || '');
                                            setSelectedEdad(item.Edad || '');
                                            setSelectedTipo(item.Tipo || '');
                                            setSelectedCategoria(item.Categoria || '');
                                            setSelectedDepartamento(item.Departamento || '');
                                            setSelectedNivelPuesto(item.NivelPuesto || '');
                                            setSelectedCargo(item.Cargo || '');
                                            setSelectedTipoVivienda(item.TipoVivienda2 || item.TipoVivienda || '');
                                            
                                            // Plaza1 es el código corto, Plaza2 es la descripción completa
                                            setPlazaCodigoCheckIn(item.Plaza1 || item.Plaza || '');
                                            setPlazaNombreCheckIn(item.Plaza2 || item.Plaza1 || '');
                                            
                                            toggleOpen("U");
                                          } else if (isReleaseIcon) {
                                            // Función de Release (Eliminar) - Actualizar foco visual
                                            setSelectedItem(item);
                                            setSelectedItemIndex(index);
                                            handleReleaseSubmit(item);
                                          }
                                        } : undefined}
                                        title={isDisabled ? `${iconObj.Name} (Deshabilitado)` : iconObj.Name || ''}
                                      ></i>
                                    );
                                  })}
                                </div>
                              </td>
                            );
                          }
                          
                          // Formato antiguo: String con clases de iconos
                          const isIcon = typeof cellValue === 'string' && 
                                        (cellValue.includes('fa-') || cellValue.includes('icon-'));
                          
                          if (isIcon) {
                            // Dividir múltiples iconos si existen (ej: "fa fa-pencil fa fa-print")
                            const iconClasses = cellValue.split(/\s+(?=fa[srbl]?\s+fa-)/);
                            
                            return (
                              <td key={index2} style={{ textAlign: 'center' }}>
                                <div className="d-flex justify-content-center align-items-center gap-3">
                                  {iconClasses.map((iconClass, iconIdx) => {
                                    const trimmedClass = iconClass.trim();
                                    // Solo el icono de lápiz abre el modal
                                    const isPencilIcon = trimmedClass.includes('fa-pencil') || trimmedClass.includes('fa-edit');
                                    
                                    return (
                                      <i 
                                        key={iconIdx} 
                                        className={trimmedClass} 
                                        style={{ fontSize: '1.2rem', cursor: 'pointer', color: '#000' }}
                                         onClick={isPencilIcon ? (e) => {
                                          e.stopPropagation(); // Evitar que se propague al tr
                                          
                                          // Debug: ver todos los campos disponibles
                                          console.log("📋 Item seleccionado para Check In:", item);
                                          console.log("📋 Campos disponibles:", Object.keys(item));
                                          console.log("📋 IdOcupacion:", item.IdOcupacion);
                                          
                                          // Validar que el item tenga IdOcupacion
                                          if (!item.IdOcupacion) {
                                            toast({
                                              type: "error",
                                              message: "No se encontró el identificador de ocupación. Por favor, consulte nuevamente."
                                            });
                                            return;
                                          }
                                          
                                          // Establecer item y actualizar el foco visual
                                          setSelectedItem(item);
                                          setSelectedItemIndex(index);
                                          
                                          // Inicializar fecha con fecha actual
                                          const today = new Date().toISOString().split('T')[0];
                                          setFechaCheckIn(today);
                                          setComentarioCheckIn('');
                                          
                                          // Llenar campos del colaborador
                                          setSelectedCodigo(item.Codigo || '');
                                          setSelectedNombre(item.Nombre || '');
                                          setSelectedGenero(item.Genero || '');
                                          setSelectedFechaNac(item.FechaNac || '');
                                          setSelectedEdad(item.Edad || '');
                                          setSelectedTipo(item.Tipo || '');
                                          setSelectedCategoria(item.Categoria || '');
                                          setSelectedDepartamento(item.Departamento || '');
                                          setSelectedNivelPuesto(item.NivelPuesto || '');
                                          setSelectedCargo(item.Cargo || '');
                                          setSelectedTipoVivienda(item.TipoVivienda || '');
                                          
                                          // Llenar campos de la plaza - probando diferentes nombres de campos
                                          const plazaNombre = item.Plaza || item.NombrePlaza || item.DescripcionPlaza || 
                                                             item.PlazaAsignada || item.CodigoPlaza || '';
                                          console.log("🏠 Plaza detectada:", plazaNombre);
                                          console.log("🏠 Intentando con:", {
                                            Plaza: item.Plaza,
                                            NombrePlaza: item.NombrePlaza,
                                            DescripcionPlaza: item.DescripcionPlaza,
                                            PlazaAsignada: item.PlazaAsignada,
                                            CodigoPlaza: item.CodigoPlaza
                                          });
                                          
                                          setPlazaCodigoCheckIn(item.CodigoPlaza || item.Plaza || '');
                                          setPlazaNombreCheckIn(plazaNombre);
                                          setPlazaCategoriaCheckIn(item.CategoriaPlaza || item.Categoria || '');
                                          setPlazaEstadoCheckIn(item.EstadoPlaza || item.Estado || '');
                                          
                                          toggleOpen("U");
                                        } : undefined}
                                        title={isPencilIcon ? "Check In" : ""}
                                      ></i>
                                    );
                                  })}
                                </div>
                              </td>
                            )
                          }

                          return (
                            <td key={index2} className={` `} style={{ textAlign: alignment }}>
                              {cellValue}
                            </td>
                          )
                        })}
                    </tr>
                  )
                })}
              </tbody>
              {model?.data?.Summary && model.data.Summary.length > 0 && (
                <tfoot>
                  <tr className="table-secondary fw-bold">
                    {headerWithoutAuditFields().map((column, index) => {
                      // Buscar si esta columna tiene un valor de summary
                      const summaryItem = model.data.Summary.find(s => s.ColumnName === column.FieldName);
                      const alignment = getColumnAlignment(column.FieldName);
                      const summaryAlign = alignment === 'right' ? 'right' : 'center';
                      
                      return (
                        <td key={index} className="fw-bold" style={{ textAlign: summaryAlign }}>
                          {summaryItem ? summaryItem.SummValue.toLocaleString('en-US') : ''}
                        </td>
                      );
                    })}
                  </tr>
                </tfoot>
              )}
            </Table>

            <div className="d-flex justify-content-between align-items-center">
              {(model?.data?.Columns && model?.data?.Rows.length > 0) && (<div className="d-flex align-items-center gap-3">
                <p className="m-0 fw-bold">Total de registros:</p>
                <span 
                  className="badge border border-black d-flex align-items-center justify-content-center" 
                  style={{ 
                    fontSize: '0.875rem', 
                    height: '25px',
                    minWidth: '70px',
                    padding: '0.25rem 0.5rem', 
                    backgroundColor: '#ffffff', 
                    color: '#495057' 
                  }}
                >
                  {recordCount.toLocaleString('en-US')}
                </span>
                
                {hasSelectedItems() && (
                  <>
                    <p className="m-0 fw-bold">Seleccionados:</p>
                    <span 
                      className="badge border border-primary d-flex align-items-center justify-content-center" 
                      style={{ 
                        fontSize: '0.875rem', 
                        height: '25px',
                        minWidth: '70px',
                        padding: '0.25rem 0.5rem', 
                        backgroundColor: '#0d6efd', 
                        color: '#fff' 
                      }}
                    >
                      {Object.values(selectedCheckboxes).filter(val => val === true).length}
                    </span>
                  </>
                )}
                
                <p className="m-0">Registros por página:</p>
                <div>
                  <select
                    className="form-select form-select-sm"
                    value={RecordsQuantity}
                    onChange={(e) => {
                      const selectedValue = Number(e.target.value);
                      console.log("📊 Selected value:", selectedValue, "Type:", typeof selectedValue);
                      setRecordsQuantity(selectedValue);
                      setCurrentPage(1);
                    }}
                  >
                    {allowedPageSizes.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.text}
                        </option>
                      );
                    }
                    )}
                  </select>
                </div>
              </div>)}
              {(model?.data?.Columns && model?.data?.Rows.length > 0) && (<Pagination className="my-0">
                <Pagination.First disabled={loading} onClick={() => setCurrentPage(1)} />
                <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage <= 1 || loading} />
                
                {/* Lógica de paginación dinámica - Muestra 5 páginas */}
                {(() => {
                  const pages = [];
                  let startPage, endPage;
                  
                  if (totalPages <= 5) {
                    // Si hay 5 páginas o menos, mostrar todas
                    startPage = 1;
                    endPage = totalPages;
                  } else {
                    // Si hay más de 5 páginas
                    if (currentPage <= 3) {
                      // Al inicio: mostrar 1, 2, 3, 4, 5
                      startPage = 1;
                      endPage = 5;
                    } else if (currentPage >= totalPages - 2) {
                      // Al final: mostrar las últimas 5
                      startPage = totalPages - 4;
                      endPage = totalPages;
                    } else {
                      // En el medio: mostrar 2 antes y 2 después de la actual
                      startPage = currentPage - 2;
                      endPage = currentPage + 2;
                    }
                  }
                  
                  // Mostrar ellipsis al inicio si es necesario
                  if (startPage > 1) {
                    pages.push(
                      <Pagination.Item 
                        key={1}
                        disabled={loading} 
                        active={false}
                        onClick={() => setCurrentPage(1)}
                      >
                        1
                      </Pagination.Item>
                    );
                    if (startPage > 2) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
                    }
                  }
                  
                  // Mostrar las páginas del rango
                  for (let i = startPage; i <= endPage; i++) {
                    pages.push(
                      <Pagination.Item 
                        key={i}
                        disabled={loading} 
                        active={currentPage === i}
                        onClick={() => setCurrentPage(i)}
                      >
                        {i}
                      </Pagination.Item>
                    );
                  }
                  
                  // Mostrar ellipsis al final si es necesario
                  if (endPage < totalPages) {
                    if (endPage < totalPages - 1) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
                    }
                    pages.push(
                      <Pagination.Item 
                        key={totalPages}
                        disabled={loading} 
                        active={false}
                        onClick={() => setCurrentPage(totalPages)}
                      >
                        {totalPages}
                      </Pagination.Item>
                    );
                  }
                  
                  return pages;
                })()}
                
                <Pagination.Next disabled={currentPage >= totalPages || loading} onClick={() => setCurrentPage(currentPage + 1)} />
                <Pagination.Last disabled={loading} onClick={() => setCurrentPage(totalPages)} />
              </Pagination>)}
            </div>
            {/* {console.log("Current Page", currentPage, "Total Pages", totalPages)} */}
          </Row>
        </Container>

        {/* Add by Victor: Agrega la maquetacion del formato en PDF */}
        <Container id="contentContainer" style={{ 
            position: 'absolute', 
            left: '-9999px', 
            top: 0,
            width: '100%' 
          }}>
          <div className="mb-4 text-center">
            <img src={logoSignos} alt="Signos Framework" width={400} />
            <h3 className="fw-bold">Signos Framework SRL</h3>
            <p>Ave. Rómulo Betancourt, Esq. Dr. Fernando A. Defilló, No. 1428 · Sector Bella Vista · Santo Domingo, República Dominicana.</p>
            <p>RNC: 1234567890</p>
            <p>Fecha: {moment().format("DD/MM/YYYY")}</p>
          </div>
          <Row className="mx-2">
            <h4 className="text-center fw-bold">{section.FormTitle}</h4>

            <Table hover size="xl" bordered className="border shadow-sm" >
              <thead className="table-secondary">
                <tr>
                  {headerWithoutAuditFields()
                    .map((item, index) => {
                      const alignment = getColumnAlignment(item.FieldName);
                      return (
                        <th key={index} className={`fw-bold`} style={{ textAlign: alignment }}>
                          {item.FieldTitle}
                        </th>
                      )
                    })}
                </tr>
              </thead>
              <tbody>
                {model?.data && model.data.Rows.map((item, index) => {
                  return (
                    <tr key={index}>
                      {headerWithoutAuditFields()
                        .map((column, index2) => {
                          const alignment = getColumnAlignment(column.FieldName);
                          
                          if (column.FieldType === "datetime" || column.FieldType === "date") {
                            return (
                              <td key={index2} style={{ textAlign: alignment }}>{moment(item[column.FieldName]).format("MM/DD/YYYY")}</td>
                            )
                          }

                          // Si es una columna de checkbox, mostrar el estado según selectedCheckboxes
                          const isCheckboxColumn = column.FieldName === 'Ok' || 
                                                   column.FieldTitle?.toLowerCase().includes('selección') ||
                                                   column.FieldTitle?.toLowerCase().includes('seleccion');
                          
                          if (isCheckboxColumn || typeof item[column.FieldName] === 'boolean') {
                          return (
                            <td key={index2} style={{ textAlign: alignment }}>
                                <div className="d-flex justify-content-center align-items-center">
                                  {selectedCheckboxes[index] ? 'Sí' : 'No'}
                                </div>
                              </td>
                            )
                          }

                          // Detectar si el valor es un icono
                          const cellValue = item[column.FieldName];
                          
                          // Intentar parsear si es un string JSON con array de iconos
                          let parsedIcons = null;
                          if (typeof cellValue === 'string' && (cellValue.trim().startsWith('[') || cellValue.trim().startsWith('{'))) {
                            try {
                              // Limpiar el JSON: eliminar comas antes de ] o }
                              let cleanedJson = cellValue
                                .replace(/,(\s*[\]}])/g, '$1') // Eliminar comas antes de ] o }
                                .replace(/\r\n/g, '') // Eliminar saltos de línea \r\n
                                .replace(/\n/g, ''); // Eliminar saltos de línea \n
                              
                              parsedIcons = JSON.parse(cleanedJson);
                              console.log(`✅ JSON parseado para PDF - columna ${column.FieldName}:`, parsedIcons);
                            } catch (e) {
                              // Si falla el parseo, continuar con el flujo normal
                              console.warn(`⚠️ No se pudo parsear el JSON de iconos (PDF) para ${column.FieldName}:`, e);
                            }
                          }
                          
                          // Si logramos parsear un array de iconos estructurados
                          if (Array.isArray(parsedIcons) && parsedIcons.length > 0 && parsedIcons[0].icon) {
                            return (
                              <td key={index2} style={{ textAlign: 'center' }}>
                                <div className="d-flex justify-content-center align-items-center gap-3">
                                  {parsedIcons.map((iconObj, iconIdx) => {
                                    const isDisabled = iconObj.Enabled === "false" || iconObj.Enabled === false;
                                    return (
                                      <i 
                                        key={iconIdx} 
                                        className={iconObj.icon} 
                                        style={{ 
                                          fontSize: '1.2rem', 
                                          color: isDisabled ? '#ccc' : '#000',
                                          opacity: isDisabled ? 0.5 : 1
                                        }}
                                      ></i>
                                    );
                                  })}
                                </div>
                              </td>
                            );
                          }
                          
                          // Formato antiguo: String con clases de iconos
                          const isIcon = typeof cellValue === 'string' && 
                                        (cellValue.includes('fa-') || cellValue.includes('icon-'));
                          
                          if (isIcon) {
                            // Dividir múltiples iconos si existen
                            const iconClasses = cellValue.split(/\s+(?=fa[srbl]?\s+fa-)/);
                            
                            return (
                              <td key={index2} style={{ textAlign: 'center' }}>
                                <div className="d-flex justify-content-center align-items-center gap-3">
                                  {iconClasses.map((iconClass, iconIdx) => {
                                    return (
                                      <i 
                                        key={iconIdx} 
                                        className={iconClass.trim()} 
                                        style={{ fontSize: '1.2rem', cursor: 'pointer', color: '#000' }}
                                      ></i>
                                    );
                                  })}
                                </div>
                              </td>
                            )
                          }

                          return (
                            <td key={index2} style={{ textAlign: alignment }}>
                              {cellValue}
                            </td>
                          )
                        })}
                    </tr>
                  )
                })}
              </tbody>
              {model?.data?.Summary && model.data.Summary.length > 0 && (
                <tfoot>
                  <tr className="table-secondary fw-bold">
                    {headerWithoutAuditFields().map((column, index) => {
                      // Buscar si esta columna tiene un valor de summary
                      const summaryItem = model.data.Summary.find(s => s.ColumnName === column.FieldName);
                      const alignment = getColumnAlignment(column.FieldName);
                      const summaryAlign = alignment === 'right' ? 'right' : 'center';
                      
                      return (
                        <td key={index} className="fw-bold" style={{ textAlign: summaryAlign }}>
                          {summaryItem ? summaryItem.SummValue.toLocaleString('en-US') : ''}
                        </td>
                      );
                    })}
                  </tr>
                </tfoot>
              )}
            </Table>
          </Row>
        </Container>
      </>
    );
  };

  //EVENTS


  // useEffect(() => {
  //   setOpen(false)
  //   setSelectedItem(null)
  //   setSelectedItemIndex(null)
  //   setActionMode(null)
  //   setGeneralError(null)
  //   setModel(initialModel);
  //   checkIfPinned();
  //   setIsSearching(true);
  //   setSearch("");
  //   setColumnFilters({});
  //   setShowTable(false); // Ocultar tabla al cambiar de reporte
  //   bindDataModelRemote();
  //   bindDataHeaderRemote();
  //   setCurrentPage(1);
  //   //bindDataRemote();

  //   return () => formik.resetForm();
  // }, [params.id]);

  // useEffect(() => {
  //   console.log("section updated", model)
  //   prepareFormikObject();
  // }, [section, fields]);
  // END EVENTS
  
  // REMOVIDO: bindDataRemote ya tiene RecordsQuantity en sus dependencias del useCallback
  // useEffect(() => {
  //   console.log("entro record quantity")
  //   bindDataRemote();
  // }, [RecordsQuantity])

  // Cargar filtros y headers al montar el componente
  useEffect(() => {
    loadFiltersAndHeaders();
  }, []); // Solo se ejecuta al montar

  useEffect(() => {
    const quantity = Number(RecordsQuantity) || 10;
    const pages = quantity > 0 ? Math.ceil(recordCount / quantity) : 1;
    console.log("Record Count", recordCount, "Records Quantity", RecordsQuantity);
    console.log("Pages calculated:", pages)
    setTotalPages(pages)
  }, [recordCount, RecordsQuantity])
  
  // Inicializar valores por defecto de los filtros cuando se cargan desde el API
  useEffect(() => {
    if (filters && filters.length > 0) {
      const defaultValues = initializeFilterDefaults(filters);
      setFilterValues(defaultValues);
      console.log("✅ Filtros inicializados con valores por defecto:", defaultValues);
    }
  }, [filters, initializeFilterDefaults]);
  
  // Recargar datos cuando cambia la página o la cantidad de registros por página
  useEffect(() => {
    // Solo ejecutar si ya se ha hecho una consulta inicial (showTable es true)
    if (showTable) {
      console.log("🔄 Recargando datos por cambio de página o cantidad de registros...");
      getTableData();
    }
  }, [currentPage, RecordsQuantity]);
  
  // Debug para ver el estado de section, fields y tableHeader
  useEffect(() => {
    console.log("🔍 Estado actual:");
    console.log("  - section:", section);
    console.log("  - fields:", fields);
    console.log("  - filters:", filters);
    console.log("  - filterValues:", filterValues);
    console.log("  - tableHeader:", tableHeader);
    console.log("  - model.data.Rows:", model?.data?.Rows);
  }, [section, fields, filters, filterValues, tableHeader, model]);
  
  return (
    <React.Fragment>
      {open ?
        <Modal
          show={open}
          onHide={() => toggleOpen(null)}
          backdrop="static"
          keyboard={false}
          dialogClassName="modal-right-medium"
          className="modalRight"
        >
          <Modal.Header>
            <Modal.Title className="fw-bold">{isMassiveCheckIn ? "Check In Masivo" : "Check In"}</Modal.Title>
            <CustomCloseButton onClose={() => toggleOpen(null)} />
          </Modal.Header>
          <Modal.Body>
            {/* Datos del Colaborador - Solo mostrar si NO es masivo */}
            {!isMassiveCheckIn && (
              <>
                <label className="me-2 mt-2 separatorTitle">Datos del Colaborador</label>
                <br />
                <hr className="separatorLine" />
                
                <Row className="mb-3">
                  {fields
                    .filter(field => field.Visible && field.FieldName !== 'Icon' && field.FieldName !== 'Ok')
                    .map((field, index) => {
                      const value = selectedItem?.[field.FieldName] || '';
                      const isReadOnly = field.ReadOnly !== false;
                      
                      return (
                        <div key={index} className={field.cssClass || 'col-12 col-md-6'}>
                          <label className="me-2 mt-3">{field.FieldTitle}</label>
                          <br />
                          {field.HtmlType === 'textarea' ? (
                            <textarea
                              className="form-control"
                              value={value}
                              readOnly={isReadOnly}
                              disabled={isReadOnly || actionMode === "C"}
                              rows={3}
                            />
                          ) : field.HtmlType === 'date' ? (
                            <DateBox
                              className={`${isReadOnly || actionMode === "C" ? "form-read-only" : ""}`}
                              readOnly={isReadOnly || actionMode === "C"}
                              id={field.FieldName}
                              name={field.FieldName}
                              placeholder={field.PlaceHolder || "Seleccione la fecha"}
                              displayFormat="dd/MM/yyyy"
                              value={value ? moment(value).isValid() ? moment(value).toDate() : null : null}
                              onValueChanged={(e) => {
                                const formattedDate = e.value ? moment(e.value).format('YYYY-MM-DD') : '';
                                // Aquí podrías actualizar el estado si es necesario
                              }}
                            />
                          ) : field.HtmlType === 'checkbox' ? (
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={!!value}
                              readOnly={isReadOnly}
                              disabled={isReadOnly || actionMode === "C"}
                            />
                          ) : field.HtmlType === 'hidden' ? null : (
                            <TextBox
                              value={value}
                              readOnly={isReadOnly}
                              disabled={isReadOnly || actionMode === "C"}
                            />
                          )}
                        </div>
                      );
                    })}
                </Row>
              </>
            )}

            {/* Campo de Fecha */}
            <label className="me-2 mt-2 separatorTitle">Información de Check-In</label>
            <br />
            <hr className="separatorLine" />
            
            <Row className="mb-3">
              <Col md={4}>
                <label className="me-2 mt-3">Fecha <span className="text-danger">*</span></label>
                <br />
                <DateBox
                  className={`${actionMode === "C" ? "form-read-only" : ""}`}
                  readOnly={actionMode === "C"}
                  id="fechaCheckIn"
                  name="fechaCheckIn"
                  placeholder="Seleccione la fecha"
                  displayFormat="dd/MM/yyyy"
                  required={true}
                  value={fechaCheckIn ? moment(fechaCheckIn).isValid() ? moment(fechaCheckIn).toDate() : null : null}
                  onValueChanged={(e) => {
                    const formattedDate = e.value ? moment(e.value).format('YYYY-MM-DD') : '';
                    setFechaCheckIn(formattedDate);
                  }}
                />
                {validationErrors.fechaCheckIn && (
                  <div className="invalid text-sm">
                    {validationErrors.fechaCheckIn}
                  </div>
                )}
              </Col>
            </Row>

            {/*

            <Row className="mb-3">
              <Col md={12}>
                <label className="me-2 mt-3">
                  Motivo <span className="text-danger">*</span>
                </label>
                <br />
                <SelectBox
                  dataSource={motivosOptions}
                  displayExpr="Descripcion"
                  valueExpr="Id"
                  value={selectedMotivo}
                  onValueChanged={(e) => setSelectedMotivo(e.value)}
                  placeholder={loadingMotivos ? "Cargando motivos..." : "Seleccione un motivo"}
                  searchEnabled={true}
                  disabled={actionMode === "C" || loadingMotivos}
                  showClearButton={true}
                />
                {validationErrors.selectedMotivo && (
                  <div className="invalid text-sm">
                    {validationErrors.selectedMotivo}
                  </div>
                )}
              </Col>
            </Row>
            
            */}

            {/* Campo de Comentario */}
            <label className="me-2 mt-3">Comentario</label>
            <br />
            
            <Row className="mb-3">
              <Col md={12}>
                <textarea
                  className="form-control"
                  rows={4}
                  placeholder="Ingrese un comentario sobre el Check In..."
                  value={comentarioCheckIn}
                  onChange={(e) => setComentarioCheckIn(e.target.value)}
                  disabled={actionMode === "C"}
                  maxLength={500}
                />
              </Col>
            </Row>
            
            {/* ===== SECCIÓN COMENTADA: Datos del Colaborador y Plazas ===== */}
            {/* <label className="me-2 mt-2 separatorTitle">Datos del Colaborador</label>
            <br />
            <hr className="separatorLine" />
            
            Primera fila de campos
            <Row className="mb-3">
              <Col md={3}>
                <label className="me-2 mt-3">Código</label>
                <br />
                <TextBox
                  value={selectedCodigo}
                  placeholder="Código"
                  disabled={true}
                  readOnly={true}
                />
              </Col>
              <Col md={3}>
                <label className="me-2 mt-3">Nombre</label>
                <br />
                <TextBox
                  value={selectedNombre}
                  placeholder="Nombre"
                  disabled={true}
                  readOnly={true}
                />
              </Col>
              <Col md={3}>
                <label className="me-2 mt-3">Género</label>
                <br />
                <TextBox
                  value={selectedGenero}
                  placeholder="Género"
                  disabled={true}
                  readOnly={true}
                />
              </Col>
              <Col md={3}>
                <label className="me-2 mt-3">Fecha Nac</label>
                <br />
                <TextBox
                  value={selectedFechaNac}
                  placeholder="Fecha Nac"
                  disabled={true}
                  readOnly={true}
                />
              </Col>
            </Row>

            Segunda fila de campos
            <Row className="mb-3">
              <Col md={3}>
                <label className="me-2 mt-3">Edad</label>
                <br />
                <TextBox
                  value={selectedEdad}
                  placeholder="Edad"
                  disabled={true}
                  readOnly={true}
                />
              </Col>
              <Col md={3}>
                <label className="me-2 mt-3">Tipo</label>
                <br />
                <TextBox
                  value={selectedTipo}
                  placeholder="Tipo"
                  disabled={true}
                  readOnly={true}
                />
              </Col>
              <Col md={3}>
                <label className="me-2 mt-3">Categoría</label>
                <br />
                <TextBox
                  value={selectedCategoria}
                  placeholder="Categoría"
                  disabled={true}
                  readOnly={true}
                />
              </Col>
              <Col md={3}>
                <label className="me-2 mt-3">Departamento</label>
                <br />
                <TextBox
                  value={selectedDepartamento}
                  placeholder="Departamento"
                  disabled={true}
                  readOnly={true}
                />
              </Col>
            </Row>

            Tercera fila de campos
            <Row className="mb-3">
              <Col md={3}>
                <label className="me-2 mt-3">Nivel Puesto</label>
                <br />
                <TextBox
                  value={selectedNivelPuesto}
                  placeholder="Nivel Puesto"
                  disabled={true}
                  readOnly={true}
                />
              </Col>
              <Col md={3}>
                <label className="me-2 mt-3">Cargo</label>
                <br />
                <TextBox
                  value={selectedCargo}
                  placeholder="Cargo"
                  disabled={true}
                  readOnly={true}
                />
              </Col>
              <Col md={3}>
                <label className="me-2 mt-3">Tipo Vivienda</label>
                <br />
                <TextBox
                  value={selectedTipoVivienda}
                  placeholder="Tipo Vivienda"
                  disabled={true}
                  readOnly={true}
                />
              </Col>
            </Row> */}

            {/* Tabla de habitaciones disponibles */}
            {/* <Row>
              <Col md={12}>
              <label className="me-2 mt-3 separatorTitle">Plazas Disponibles</label>
              <br />
              <hr className="separatorLine" />
                <Table hover bordered className="border shadow-sm" size="sm">
                  <thead className="table-secondary">
                    <tr>
                      <th>Código</th>
                      <th>Plaza</th>
                      <th>Categoría</th>
                      <th>Estado</th>
                      <th>Ocupante</th>
                      <th className="text-center">Fecha Salida</th>
                      <th>Motivo Salida</th>
                      <th>Comentario</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detailItems.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center text-muted">
                          No hay plazas disponibles.
                        </td>
                      </tr>
                    ) : (
                      detailItems.map((item, index) => (
                        <tr key={item.Id}>
                          <td>{item.Codigo}</td>
                          <td>{item.Plaza}</td>
                          <td>{item.Categoria}</td>
                          <td>{item.Estado}</td>
                          <td>{item.Ocupante}</td>
                          <td className="text-center">{item.FechaSalida}</td>
                          <td>{item.MotivoSalida}</td>
                          <td>{item.ComentarioSalida}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row> */}
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex gx-3 align-items-center justify-content-end">
              {Object.keys(validationErrors).length > 0 && (
                <span className="invalid me-2">
                  Por favor, verificar los errores en el formulario
                </span>
              )}
              
              <button 
                className='btn btn-cancel-hover me-2' 
                type="button" 
                onClick={() => toggleOpen(null)} 
                style={{ width: "155px", height: "40px" }}
              >
                {actionMode === "C" ? "Cerrar" : "Cancelar"}
              </button>
              {actionMode !== "C" && (
                <button 
                  className="btn btn-success" 
                  type="button" 
                  onClick={handleCheckInSubmit}
                  style={{ width: "155px", height: "40px" }}
                >
                  Check-In
                </button>
              )}
            </div>
          </Modal.Footer>
        </Modal> : null}
      
      {/* Panel de Filtros - Título y Card en divs separados */}
{isSearching && (
  <Container>
    <Breadcrumbs pathTitle={section?.FormPath} />
    
    {/* Bloque del Título */}
    <div className="row mx-0">
      <div className="col-12 d-flex align-items-center"
         style={{ marginBottom: "12px" }}>
        <i className={(section.FormIcon || "fa fa-users") + " me-3 fa-2x"}></i>
        <div className="d-flex flex-column">
          <h5 className="my-0">{section.FormTitle}</h5>
        </div>
      </div>
    </div>

    {/* Bloque de la Card de Filtros */}
    <div className="row mx-0">
      <div className="col-12">
        <Card className="mb-4">
          <Card.Body className="formBackground">
            <Row>
              {/* Mensaje de carga de filtros */}
              {loadingFilters && filters.length === 0 ? (
                <Col md={12} className="text-center text-muted py-4">
                  Cargando filtros...
                </Col>
              ) : (
                <>
                  {/* Generar filtros dinámicamente desde el API */}
                  {filters && filters.length > 0 ? (
                    filters.map((filter, index) => (
                      <div key={filter.FieldName} className={filter.cssClass || 'col-12 col-md-6'}>
                        <label className="form-label small fw-bold">
                          {filter.FieldTitle || filter.FieldName}
                          {filter.Required && <span className="text-danger ms-1">*</span>}
                        </label>
                        
                        {filter.HtmlType === 'date' && (
                          <DateBox
                            id={filter.FieldName}
                            name={filter.FieldName}
                            placeholder={filter.PlaceHolder || `Seleccione ${filter.FieldTitle}`}
                            displayFormat="dd/MM/yyyy"
                            value={filterValues[filter.FieldName] ? moment(filterValues[filter.FieldName]).isValid() ? moment(filterValues[filter.FieldName]).toDate() : null : null}
                            onValueChanged={(e) => {
                              const formattedDate = e.value ? moment(e.value).format('YYYY-MM-DD') : '';
                              setFilterValues({
                                ...filterValues,
                                [filter.FieldName]: formattedDate
                              });
                            }}
                          />
                        )}
                        
                        {filter.HtmlType === 'text' && (
                          <TextBox
                            value={filterValues[filter.FieldName] || filter.DefaultValue || ''}
                            onValueChanged={(e) => setFilterValues({
                              ...filterValues,
                              [filter.FieldName]: e.value
                            })}
                            placeholder={filter.PlaceHolder || `Ingrese ${filter.FieldTitle}`}
                          />
                        )}
                        
                        {filter.HtmlType === 'select' && (
                          <SelectBox
                            dataSource={filter.Options || []}
                            displayExpr="name"
                            valueExpr="id"
                            value={filterValues[filter.FieldName] || filter.DefaultValue || ''}
                            onValueChanged={(e) => setFilterValues({
                              ...filterValues,
                              [filter.FieldName]: e.value
                            })}
                            placeholder={filter.PlaceHolder || `Seleccione ${filter.FieldTitle}`}
                            searchEnabled={true}
                          />
                        )}
                      </div>
                    ))
                  ) : (
                    <Col md={12} className="text-center text-muted">
                      No hay filtros disponibles
                    </Col>
                  )}
                </>
              )}
            </Row>
          </Card.Body>
        </Card>

        {/* Botones de acción debajo de la Card */}
        <div className="mb-3">
          <button
            className="btn btn-outline-secondary me-2"
            type="button"
            title="Limpiar todos los filtros"
            onClick={clearAllFilters}
            disabled={loadingFilters}
            style={{ width: '155px', height: '40px', fontSize: '1.1rem' }}
          >
            <i className="fa-solid fa-filter-circle-xmark me-1"></i>
            Limpiar
          </button>
          <button
            className="btn btn-primary"
            title="Consultar datos"
            type="button"
            disabled={loadingFilters}
            onClick={async () => {
              setShowTable(true);
              setCurrentPage(1);
              await getTableData();
            }}
            style={{ width: '155px', height: '40px', fontSize: '1.1rem' }}
          >
            {loadingFilters ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Cargando...
              </>
            ) : (
              <>
                <Search className="me-1" />
                Consultar
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  </Container>
)}

      {/* Sección del título y tabla */}
      <Container>
        <div className="row mx-0" >
          <div className="col-12">
            <div className="d-flex flex-wrap align-items-center justify-content-end mb-2 mt-2">

              {loading ? (
                <React.Fragment>
                  <div className="">
                    <div className="w-25 mx-auto my-1" style={{ paddingTop: "" }}>
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Cargando...</span>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : null}
              <div className="w-auto d-flex align-items-center">

                {actionMode === null ? (
                  <>
                  {/*
                  
                    <button className="btn btn-sm btn-primary my-1 me-2" title="Crear" disabled={loading} onClick={() => toggleOpen("I")}>
                      <i className="fa fa-plus"></i>
                    </button>
                    <button 
                      className="btn btn-sm my-1 me-2"
                      title="Actualizar" 
                      disabled={loading} 
                      onClick={async () => {
                        await bindDataRemote();
                        await bindDataCountRemote();
                      }}
                      style={{
                        backgroundColor: '#6c757d',
                        borderColor: '#6c757d',
                        color: '#fff'
                      }}
                    >
                      <i className="fa fa-sync"></i>
                    </button>
                  */}
                    {!isSearching && (
                      <button className={`btn btn-sm my-1 me-2`} title="Buscar" onClick={() => setIsSearching(true)}>
                        <i className="fa-solid fa-magnifying-glass"></i>
                      </button>
                    )}
                  </>
                ) : null}
                {/* Botones de Actualizar y Ver deshabilitados para CheckIn */}
                {/* {selectedItem ? (
                  <>
                    <button className="btn btn-sm  my-1 me-2" title="Actualizar" disabled={loading} onClick={() => toggleOpen("U")} aria>
                      <i className="fa fa-pencil"></i>
                    </button>
                    <button className="btn btn-sm  my-1 me-2" title="Ver" disabled={loading} onClick={() => toggleOpen("C")}>
                      <i className="fa fa-eye"></i>
                    </button>
                  </>
                ) : null} */}


                {showTable && (
                  <>
                    {/* Botón de Imprimir Masivo - Solo aparece cuando hay más de 1 registro seleccionado */}
                    {getSelectedItems().length > 1 && (
                      <button 
                        className="btn btn-sm my-1 me-2" 
                        title="Imprimir seleccionados"
                        onClick={handlePrintMassive}
                        disabled={loading}
                      >
                        <i className="fa fa-print" style={{ fontSize: '1.2rem' }}></i>
                      </button>
                    )}

                    {/* Botón de Check In Masivo - Solo aparece cuando hay más de 1 registro con CheckIn habilitado */}
                    {getSelectedItemsWithCheckInEnabled().length > 1 && (
                      <button 
                        className="btn btn-sm my-1 me-2" 
                        title="Check In Masivo"
                        onClick={handleMassiveCheckIn}
                        disabled={loading}
                      >
                        <i className="fa-solid fa-pen-to-square" style={{ fontSize: '1.2rem' }}></i>
                      </button>
                    )}

                    {/* Botón de Release Masivo - Solo aparece cuando hay 2 o más registros con CheckIn habilitado */}
                    {getSelectedItemsWithCheckInEnabled().length >= 2 && (
                      <button 
                        className="btn btn-sm my-1 me-2" 
                        title="Liberar Masivo"
                        onClick={handleMassiveRelease}
                        disabled={loading}
                      >
                        <i className="fa-solid fa-trash-can" style={{ fontSize: '1.2rem' }}></i>
                      </button>
                    )}

                    <Dropdown>
                      <Dropdown.Toggle variant="button" id="dropdown-basic">
                        <i className="fa fa-ellipsis-v" />
                      </Dropdown.Toggle>

                      <Dropdown.Menu align="end">
                        {isPinned ? <Dropdown.Item onClick={() => { addFavorite() }}>Remover de favoritos</Dropdown.Item> : <Dropdown.Item onClick={() => { addFavorite() }}>Agregar a favoritos</Dropdown.Item>}
                        <Dropdown.Divider />
                       


                        {actionMode === null ?
                          <Dropdown.Item onClick={() => { exportToExcel() }}>Exportar a Excel</Dropdown.Item> : null}
                        
                          <Dropdown.Item
                            onClick={() => { exportToPDF() }}>Exportar a PDF</Dropdown.Item>

                        <Dropdown.Item
                          onClick={() => { handlePrint() }}>Imprimir</Dropdown.Item>

                        <Dropdown.Divider />
                        
                      </Dropdown.Menu>
                    </Dropdown>
                  </>
                )}

              </div>
            </div>
            {showTable && loadGRIDUI()}
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
}
